{
  "common": {
    "appTitle": "Draughts MVP",
    "back": "Voltar",
    "exit": "Sair",
    "cancel": "Cancelar",
    "close": "Fechar",
    "continue": "Continuar",
    "copy": "Copiar",
    "error": "Erro",
    "loading": "Carregando...",
    "retry": "Tentar de novo",
    "or": "ou",
    "vs": "vs",
    "you": "Você",
    "anonymous": "Anônimo",
    "send": "Enviar",
    "download": "Baixar",
    "noLimit": "Sem limite",
    "comingSoon": "Em breve",
    "version": "v{{version}}",
    "enabled": "Ativado",
    "disabled": "Desativado",
    "apply": "Aplicar",
    "errorBoundary": "Algo deu errado. Tente recarregar: se uma versão nova acabou de sair, o recarregamento vai pegá-la.",
    "dismissNotice": "Fechar"
  },
  "errors": {
    "loadFailed": "Não foi possível carregar estes dados. Tente de novo.",
    "network": "Sem conexão à internet. Verifique a rede e tente de novo.",
    "notFound": "Esta página não existe (ou já não existe)."
  },
  "senzaRete": {
    "titolo": "Você está sem conexão",
    "dati": "Esta página não consegue carregar seus dados até a conexão voltar.",
    "home": "Partidas online, torneios e o ranking não estão disponíveis. Você ainda pode jogar contra o computador ou presencialmente neste dispositivo."
  },
  "avvisoServizio": {
    "etichetta": "Aviso de serviço",
    "preset": {
      "riavvio": "Reinício programado: o servidor ficará indisponível por alguns instantes. As partidas em andamento não são perdidas.",
      "riavvioAlle": "Reinício programado às {{ora}}: o servidor ficará indisponível por alguns instantes. As partidas em andamento não são perdidas.",
      "manutenzione": "Manutenção em andamento: algumas funções podem ficar indisponíveis.",
      "manutenzioneAlle": "Manutenção a partir das {{ora}}: algumas funções podem ficar indisponíveis.",
      "rallentamenti": "O servidor está mais lento que o normal. Estamos trabalhando nisso."
    }
  },
  "nav": {
    "play": "Jogar",
    "home": "Home",
    "arena": "Arena",
    "tournaments": "Torneios",
    "leaderboard": "Ranking",
    "profile": "Perfil",
    "myGames": "Minhas partidas",
    "logout": "Sair",
    "signIn": "Entrar",
    "backToLocal": "Voltar ao jogo local",
    "backToTournaments": "Voltar aos torneios",
    "backToGames": "Voltar às partidas",
    "loginRequired": "É preciso entrar",
    "faq": "Dúvidas e contato",
    "rules": "Regras",
    "editor": "Editor",
    "strumenti": "Tools"
  },
  "gara": {
    "torneoInCorso": "Torneio em andamento",
    "arenaInCorso": "Arena em andamento"
  },
  "strumenti": {
    "titoloFoglio": "Tools (Ferramentas)",
    "orologio": "Relógio",
    "estraiApertura": "Sortear abertura"
  },
  "orologio": {
    "titolo": "Relógio de mesa",
    "sottotitolo": "Coloque o telefone entre os jogadores: quem moveu toca a própria metade",
    "tocca": "Toque para começar",
    "pausa": "Pausar",
    "riprendi": "Retomar",
    "azzera": "Zerar",
    "impostazioni": "Ajustes",
    "suoni": "Sons",
    "suonoTocco": "Som do toque",
    "suonoPocoTempo": "Som de tempo curto",
    "tempo": "Tempo",
    "stessoTempo": "Mesmo tempo para ambos",
    "scaduto": "Tempo esgotado",
    "mosse": "Lances"
  },
  "apertura": {
    "sottotitolo": "Sorteie uma abertura oficial",
    "andataRitorno": "Esta abertura pode favorecer uma cor: em competição joga-se ida e volta, com as cores invertidas.",
    "estrai": "Sortear",
    "estraiDiNuovo": "Sortear de novo",
    "vediTabelle": "Ver as tabelas completas",
    "posizioneIniziale": "Posição inicial"
  },
  "editor": {
    "title": "Editor",
    "subtitle": "Monte uma posição para estudar, analisar ou jogar",
    "boardLabel": "Tabuleiro editável",
    "sideToMove": "Quem joga",
    "reset": "Refazer",
    "clear": "Limpar",
    "flip": "Girar",
    "playPosition": "Jogar posição",
    "playAI": "Jogar contra o computador",
    "challenge": "Desafiar um amigo",
    "challengeNote": "A partida começa da posição que você montou e é sempre amistosa (sem rating).",
    "tools": {
      "label": "Peças",
      "whiteMan": "Pedra branca",
      "whiteKing": "Dama branca",
      "blackMan": "Pedra preta",
      "blackKing": "Dama preta",
      "erase": "Apagar",
      "cycle": "Trocar peça"
    },
    "library": {
      "open": "Posições salvas",
      "title": "Posições salvas",
      "nameLabel": "Nome",
      "namePlaceholder": "Nome da posição",
      "defaultName": "Posição",
      "defaultNameAnalysis": "Análise",
      "save": "Salvar",
      "overwrite": "Substituir",
      "willOverwrite": "“{{name}}” será substituída.",
      "saved": "Na sua biblioteca",
      "empty": "Nenhuma posição salva ainda. Monte uma posição e guarde aqui.",
      "load": "Carregar {{name}}",
      "lineBadge_one": "{{count}} lance",
      "lineBadge_other": "{{count}} lances",
      "askLoad": "Carregar “{{name}}”? A posição do tabuleiro será substituída.",
      "askLoadLine": "Carregar “{{name}}”? A posição e a linha que você está jogando serão substituídas.",
      "confirmLoad": "Carregar",
      "rename": "Renomear {{name}}",
      "share": "Compartilhar {{name}}",
      "shareCopied": "Link copiado",
      "shareTitle": "Posição de damas",
      "shareText": "Dá uma olhada nesta posição de damas",
      "delete": "Excluir {{name}}",
      "askDelete": "Excluir “{{name}}”?",
      "confirmDelete": "Excluir",
      "errors": {
        "nameTaken": "Já existe uma posição com este nome.",
        "full": "Biblioteca cheia: exclua uma posição para salvar outra.",
        "saveFailed": "Não foi possível salvar. Tente de novo.",
        "deleteFailed": "Não foi possível excluir. Tente de novo.",
        "loadFailed": "Não foi possível ler esta posição.",
        "loadListFailed": "Não foi possível carregar a sua biblioteca.",
        "shareFailed": "Não foi possível copiar o link."
      }
    },
    "fen": {
      "label": "Posição (FEN)",
      "copy": "Copiar FEN",
      "copied": "Copiado",
      "invalid": "FEN inválido."
    },
    "analysis": {
      "title": "Análise",
      "hint": "Jogue pelas duas cores. Volte atrás e faça outro lance para mudar a linha.",
      "save": "Salvar análise",
      "run": "Analisar",
      "depth": "Profundidade",
      "fast": "Rápida",
      "standard": "Normal",
      "deep": "Funda",
      "evaluation": "Avaliação",
      "cancel": "Cancelar",
      "reached": "Profundidade atingida"
    },
    "invalid": {
      "noWhite": "Ponha pelo menos uma peça branca.",
      "noBlack": "Ponha pelo menos uma peça preta.",
      "manOnPromotionRow": "Uma pedra não pode ficar na fila de promoção — vire dama ou mude de casa.",
      "tooManyPieces": "Peças demais para esta variante.",
      "sideToMoveNoMoves": "Quem joga não tem nenhum lance legal.",
      "alreadyTerminal": "Esta posição já está decidida (ganha ou empatada).",
      "offBoard": "Uma peça está em uma casa que esta variante não possui.",
      "duplicateSquare": "Duas peças na mesma casa."
    }
  },
  "rules": {
    "channels": {
      "cta": "Canais recomendados",
      "title": "Canais recomendados",
      "note": "Canais que recomendamos para assistir e estudar esta variante.",
      "opensOnYouTube": "Abre no YouTube"
    },
    "backToRules": "Todas as regras",
    "playOnline": "Jogar agora",
    "playAI": "Jogar contra o computador",
    "indexTitle": "Regras das damas",
    "indexIntro": "Dois regulamentos num só lugar: as regras de jogo de todas as variantes que oferecemos e as regras pelas quais funcionam os nossos torneios online.",
    "gameTitle": "Regras das damas por variante",
    "gameIntro": "As damas — conhecidas também como checkers, dama, dammen e damas — são jogadas no mundo inteiro, cada região com as suas próprias regras. Veja abaixo as regras de todas as variantes que oferecemos.",
    "gameCtaDesc": "Tabuleiro, movimentos, capturas e promoção — variante por variante.",
    "heroSubtitle": "Regras, posição inicial e como jogar {{variant}}.",
    "startingPosition": "Posição inicial",
    "howToPlay": "Como se joga",
    "otherVariants": "Outras variantes",
    "eyebrow": "Regras",
    "glance": {
      "title": "Num relance",
      "board": "Tabuleiro",
      "pieces": "Peças de cada lado",
      "starts": "Primeiro lance"
    },
    "theme": {
      "movement": "Movimento",
      "capture": "Capturas",
      "promotion": "Promoção"
    },
    "variantsLabel": "Variantes",
    "draughtsWord": "damas",
    "tournaments": {
      "title": "Regras dos torneios",
      "heroSubtitle": "Tudo o que um torneio decide sozinho, do número de rodadas aos desempates.",
      "intro": "Depois de começar, um torneio anda sozinho: conta os inscritos presentes, escolhe o sistema de emparceiramento, fixa o número de rodadas e monta a classificação. Estas são as regras que ele aplica, na ordem em que as aplica.",
      "source": "Fonte: FIDE C.04.1 e FMJD Annex 3, adaptados ao jogo on-line.",
      "cta": "Como funciona um torneio",
      "ctaDesc": "Formato, rodadas, inscrição, ausências, desempates e a arena.",
      "chaptersLabel": "Capítulos",
      "format": {
        "title": "Formato",
        "body": [
          "Um só formato por rodadas, o todos contra todos/suíço: quem abre um torneio não escolhe entre pontos corridos e sistema suíço, escolhe um limiar de inscritos. Ao lado dos torneios existe a arena, que é outra coisa: veja o capítulo “A arena”.",
          "Na hora de começar, contam-se os inscritos realmente presentes. Abaixo do limiar joga-se em pontos corridos: todos contra todos, pelas tabelas de Berger. A partir do limiar joga-se pelo sistema suíço: a cada rodada você é emparelhado com jogadores da sua mesma pontuação, e nunca se enfrenta o mesmo adversário duas vezes.",
          "O limiar padrão é 7 e pode ser ajustado entre 7 e 20; o formato de pontos corridos aceita no máximo 19 inscritos.",
          "A razão é simples: ao abrir um torneio ninguém sabe quantos virão, e escolher o formato antes é escolher às cegas.",
          "Vitória 2 pontos, empate 1 ponto, derrota zero. Se os inscritos forem em número ímpar, a cada rodada um descansa, e quanto vale esse descanso depende do formato: no suíço vale 2 pontos como uma vitória — 4 num torneio de ida e volta, onde cada rodada são duas partidas — enquanto em pontos corridos não dá ponto nenhum, porque ali cada um enfrenta todos os outros e o descanso é apenas uma rodada que não se joga. Em nenhum dos dois casos conta como partida vencida nem entra nos critérios de desempate."
        ]
      },
      "rounds": {
        "title": "Número de rodadas",
        "body": [
          "O número é fixado no início do torneio, contando os inscritos presentes. Com o limiar padrão, por número de inscritos:",
          "Um torneio aceita no máximo 200 inscritos, então dez rodadas é o máximo — onze com a rodada extra.",
          "Em pontos corridos as rodadas são as necessárias para que cada um enfrente todos os outros. Com três ou quatro inscritos a ida e volta é sempre jogada, seja lá o que tenha escolhido quem abriu o torneio: cada rodada passa a ter duas partidas, porque com apenas uma partida por adversário uma derrota na primeira rodada já decidiria o torneio. Com quatro são três rodadas e seis partidas por pessoa; com três jogam-se essas mesmas três rodadas, mas a cada vez alguém descansa, então cada um descansa uma vez e joga quatro partidas — e a rodada de descanso não dá pontos.",
          "No suíço, dobrar o número de participantes acrescenta uma rodada: cada rodada reduz pela metade quem ainda pode terminar com pontuação perfeita. É uma rodada a mais do que precisaria um torneio eliminatório, pois de outro modo dois jogadores poderiam terminar empatados na liderança sem nunca terem se enfrentado.",
          "Dois interruptores mudam a conta. «Rodada extra» acrescenta uma à tabela quando o campo aguenta, e só vale se o início produzir um suíço: em pontos corridos todos já se enfrentam, e uma rodada a mais seria apenas uma revanche para todos. Já «Ida e volta» não acrescenta rodadas, preenche-as: cada emparelhamento é jogado duas vezes seguidas, com as cores invertidas e sobre a mesma abertura, dentro da mesma rodada, que portanto dura o dobro. Funciona igual em pontos corridos e no suíço, e os pontos continuam por partida: uma vitória e um empate dão 3, duas vitórias 4."
        ],
        "rounds": [
          "3-4 — pontos corridos, 3 rodadas",
          "5-6 — pontos corridos, 5 rodadas",
          "7-8 — suíço, 4 rodadas",
          "9-16 — suíço, 5 rodadas",
          "17-32 — suíço, 6 rodadas",
          "33-64 — suíço, 7 rodadas",
          "65-128 — suíço, 8 rodadas",
          "129-192 — suíço, 9 rodadas",
          "193-200 — suíço, 10 rodadas"
        ]
      },
      "entry": {
        "title": "Inscrição e desistência",
        "body": [
          "Abrir um torneio pode qualquer pessoa com conta registrada: não é preciso permissão e não há organizador oficial. Convidados e computadores não entram em torneios, nem para abri-los nem para jogá-los.",
          "Três competições vivas por pessoa: você pode manter até três torneios ou arenas abertos ao mesmo tempo; para abrir outro, espere que um termine ou cancele-o.",
          "Um torneio se programa, não se dispara na mão: o início é marcado entre cinco minutos e catorze dias à frente. Quem o abre apenas o organiza: para jogar precisa apertar «Inscrever-se» na página do torneio, como todos os outros, e enquanto não fizer isso não conta para o número — um mínimo de 3 pede três pessoas além dele.",
          "As vagas vão de 3 a 200. O mínimo para começar é 3, e quem abre pode aumentá-lo: se na hora de começar houver menos inscritos que o mínimo, o torneio se cancela sozinho. Enquanto não tiver começado, quem o abriu pode cancelá-lo; depois não, porque quem está jogando tem direito de terminar.",
          "Um torneio pode ser privado: entra-se apenas com a senha escolhida por quem o abriu, ou com o link de convite.",
          "A inscrição vai até a primeira rodada começar, e até ali também dá para se retirar — quem cancela a inscrição antes do início some da classificação na hora, porque ainda não jogou nada. Dali em diante a porta se fecha nos dois sentidos: quem está dentro fica na chave, porque retirar-se no meio deixaria um adversário sem partida em cada rodada restante."
        ]
      },
      "absences": {
        "title": "Ausências",
        "body": [
          "Depende de onde você estava, e os três casos terminam de três maneiras diferentes.",
          "Se você estiver simplesmente desconectado, a partida abre do mesmo jeito e o seu relógio começa a correr. Chegar três minutos atrasado significa jogar com três minutos a menos, não perder a partida: só se você nunca chegar é que perde por tempo. Uma partida em que um dos dois nunca se sentou não mexe na pontuação de nenhum deles.",
          "O mesmo vale se você se conectar e a conexão cair antes do seu primeiro lance: quem decide é o seu relógio. Depois do primeiro lance, se você cair, tem 30 segundos para voltar, como em qualquer partida.",
          "Se, em vez disso, você já estiver ocupado em outra partida — uma arena, um desafio, outro torneio —, a partida da rodada não abre e você leva uma derrota por ausência, com os 2 pontos indo para o seu adversário. Não é punição: abrir um segundo tabuleiro para você tornaria inalcançável aquele em que já está jogando.",
          "Se faltarem os dois, a rodada fecha em 0-0 e ninguém leva nada. Um empate de ofício premiaria a ausência.",
          "Em nenhum dos três casos a pessoa é excluída: na rodada seguinte é emparelhada como sempre.",
          "Uma última coisa vale para todos: um torneio tem uma duração anunciada, e se a essa hora ainda houver partidas em andamento, elas ganham dez minutos. Passados esses, o torneio fecha e as partidas ainda abertas são dadas como empate."
        ]
      },
      "openingMoves": {
        "title": "Aberturas",
        "body": [
          "Depende de como o torneio foi aberto, e há nove modos.",
          "«Lance livre» é o normal: joga-se desde o primeiro lance, e nada é imposto.",
          "Depois vêm os sorteios. Três deles põem um, dois ou três lances legais ao acaso, e valem em qualquer variante. Outros quatro sorteiam de uma tabela oficial F.I.D., e só existem na italiana e na inglesa, as duas variantes que têm tabela federativa: o que se escolhe ali é quão desequilibrada pode ser a abertura que sair — até 1N/1B, até 2N/2B, até 3N/3B, ou todas as 174. No suíço a mesma abertura não sai duas vezes no mesmo torneio.",
          "E há ainda o torneio temático: quem abre escolhe UMA das 174 aberturas oficiais, e todos a jogam, em todas as rodadas e em todas as partidas. É o único caso em que a abertura se conhece antes de começar, e o único em que a regra «nunca duas vezes a mesma» não vale — seria exatamente o contrário do que um torneio temático pede.",
          "Com ida e volta as duas partidas de uma rodada são jogadas sobre a mesma abertura com as cores invertidas: é assim que uma abertura desequilibrada deixa de favorecer alguém."
        ]
      },
      "rated": {
        "title": "Torneios valendo rating",
        "body": [
          "Se o torneio for valendo pontuação, sim — e não numa classificação à parte: as partidas de torneio mexem na mesma pontuação de todas as outras, a da variante e do ritmo em que se joga. Quem abre o torneio decide, e por padrão vale pontuação.",
          "Um torneio ou uma arena que valem pontuação podem ter uma pontuação mínima para entrar, em degraus de 1000 até 2000: mede-se pela sua pontuação naquela variante e naquele ritmo, não por uma geral. Nos amistosos esse mínimo não existe, porque a pontuação não se mexe e não há nada a proteger. Teto não há: ninguém fica de fora por ser forte demais.",
          "Há ainda algo que pode desligar a pontuação por si só, e é a abertura. A regra federativa diz que uma única partida basta enquanto a abertura chegar a 2N/2B; acima disso a vantagem de uma cor é grande demais para uma partida só compensar, e é preciso ida e volta. Vale nos dois casos: num sorteio conta o teto da tabela de onde se sorteia, num torneio temático conta a força da abertura escolhida, que ali já se conhece. Se a combinação não se sustenta, o torneio nasce amistoso em vez de ser recusado — e ligar a ida e volta o devolve a valendo pontuação.",
          "Por fim, não valem pontuação as partidas em que um dos dois nunca se sentou."
        ]
      },
      "tiebreaks": {
        "title": "Critérios de desempate",
        "body": [
          "Depende do formato.",
          "No sistema suíço, nesta ordem:",
          "1. Buchholz Cut 1: a soma dos pontos finais de todos os adversários enfrentados, descontado o mais fraco. Premia quem teve o caminho mais difícil. O descanso não entra na conta, porque não é um adversário.",
          "2. Sonneborn-Berger: os pontos de quem você venceu, mais metade dos pontos de quem você empatou. Premia quem venceu os mais fortes.",
          "3. O número de vitórias.",
          "4. A variação de rating no torneio: quantos pontos de rating você ganhou ou perdeu nas partidas deste torneio. Premia quem rendeu mais do que o esperado, não quem já era mais forte. Quem continua empatado divide a posição.",
          "Na classificação, Buchholz e Sonneborn-Berger vêm depois de vitórias, empates, derrotas e folgas, abreviados como BH e SB.",
          "Em pontos corridos os critérios de desempate são outros, porque todos enfrentam todos e o Buchholz não distinguiria ninguém: primeiro o número de vitórias, depois o confronto direto apenas entre os jogadores com a mesma pontuação, depois o Sonneborn-Berger (SB) e, por fim, a variação de rating no torneio. Se continuarem empatados, fica à frente quem tem o melhor número na tabela, ou seja, o rating mais alto no início do torneio: em pontos corridos não há posições divididas. BH não aparece, porque, quando todos enfrentam todos, ele é apenas o inverso dos pontos. Na classificação, «CD» marca quem fica à frente pelo confronto direto."
        ]
      },
      "sharedPlaces": {
        "title": "Empate na classificação",
        "body": [
          "No suíço, acontece em torneios pequenos quando todas as partidas terminam empatadas: mesmos pontos, mesmo Buchholz, mesmo Sonneborn-Berger, nenhuma vitória.",
          "Nesse caso a posição é compartilhada. Dois primeiros empatados levam os dois o ouro, e a posição seguinte é a terceira: 1, 1, 3, como em qualquer classificação esportiva. Ninguém é colocado à frente de outro por causa do rating ou por ter se inscrito antes.",
          "Uma ressalva: no histórico do torneio fica registrado um único nome como vencedor, porque aquele campo aceita um. A classificação e o pódio mostram todos os empatados."
        ]
      },
      "arena": {
        "title": "A arena",
        "body": [
          "A outra competição que se pode abrir, e não é um torneio por rodadas: não tem rodadas nem calendário, tem uma duração. Abre, dura de dez minutos a oito horas, e enquanto está aberta você é emparelhado de novo assim que termina, sem esperar que os outros acabem a partida deles. Entra-se e sai-se quando se quer, mesmo com a competição já começada.",
          "Com a mesma pessoa, porém, espera-se: cinco minutos para cada partida já jogada juntos. A primeira revanche vem depois de cinco minutos, a segunda depois de dez, a terceira depois de quinze, e não há teto. Serve para que uma arena não vire o mesmo duelo repetido sem fim.",
          "Pontuação: vitória 2, empate 1, derrota zero, como no torneio.",
          "E há o boost, a ser tomado antes do próprio primeiro lance: dobra os pontos de uma vitória e se paga com o relógio — o incremento vai embora inteiro, e o tempo base cai pela metade. É uma aposta, não um presente.",
          "Em caso de empate de pontos, conta quem venceu mais partidas."
        ]
      }
    },
    "seo": {
      "title": "Regras de {{variant}} — como se joga",
      "description": "Aprenda as regras de {{variant}}: tamanho do tabuleiro, posição inicial, como as pedras e as damas andam e capturam, e como se vence. Jogue {{draughtsWord}} online de graça.",
      "indexTitle": "Regras das damas — regras do jogo e regras dos torneios",
      "indexDescription": "Dois regulamentos para as {{draughtsWord}}: as regras de jogo de cada variante — internacional, italiana, turca, frísia e mais — e as regras dos nossos torneios online.",
      "gameTitle": "Regras das damas por variante — como se joga",
      "gameDescription": "Regras e guias de como jogar todas as variantes de {{draughtsWord}}: internacional, italiana, turca, frísia, brasileira e muitas outras. Jogue online de graça.",
      "openingsTitle": "{{variant}}: tabelas de abertura oficiais da F.I.D.",
      "openingsDescription": "As 174 aberturas oficiais de {{variant}} com o seu código de força e as tabelas federais A, B, C e D. Regolamento Tecnico F.I.D. 2025.",
      "captureTitle": "{{variant}}: as regras de captura completas",
      "captureDescription": "Todas as regras de captura de {{variant}}: quando capturar é obrigatório, as capturas múltiplas, a precedência que decide qual captura você deve jogar e a promoção. Com exemplos no tabuleiro.",
      "tournamentsTitle": "Regras dos torneios — como funciona um torneio de {{draughtsWord}}",
      "tournamentsDescription": "As regras dos torneios de {{draughtsWord}} on-line: formato todos contra todos/suíço, número de rodadas, inscrição e desistência, ausências, sorteio da abertura, rating, desempates e a arena."
    },
    "fact": {
      "board": "Jogado num tabuleiro {{size}}×{{size}}, só nas casas escuras.",
      "boardAllSquares": "Jogado num tabuleiro {{size}}×{{size}}, usando todas as casas.",
      "pieces": "Cada jogador começa com {{count}} peças.",
      "startsWhite": "As brancas jogam primeiro.",
      "startsBlack": "As pretas jogam primeiro.",
      "moveDiagonal": "As pedras andam na diagonal para a frente, uma casa por vez.",
      "moveOrthogonal": "As pedras andam na ortogonal — para a frente e para os lados —, uma casa por vez.",
      "captureDiagonal": "As capturas são feitas na diagonal, saltando por cima de uma peça adversária vizinha.",
      "captureOrthogonal": "As capturas são feitas na ortogonal, saltando por cima de uma peça adversária vizinha.",
      "captureMixed": "As capturas podem ser feitas tanto na diagonal quanto na ortogonal.",
      "menCaptureBackwardYes": "As pedras podem capturar para a frente e para trás.",
      "menCaptureBackwardNo": "As pedras só capturam para a frente.",
      "kingFlying": "As damas “voam”: andam e capturam atravessando quantas casas vazias quiserem ao longo de uma linha.",
      "kingShort": "As damas andam uma casa por vez (não voam).",
      "menCaptureKingYes": "As pedras podem capturar damas.",
      "menCaptureKingNo": "As pedras não podem capturar damas.",
      "maxCapturePieces": "Capturar é obrigatório, e você precisa fazer a sequência que come mais peças.",
      "maxCaptureValue": "Capturar é obrigatório e você precisa fazer a sequência de maior valor: uma dama vale mais que uma pedra, mas duas pedras valem mais que uma dama.",
      "captureMandatoryFree": "Capturar é obrigatório, mas você escolhe livremente qual captura fazer.",
      "kingPriorityTie": "Quando as capturas empatam nos outros critérios, é preciso capturar com uma dama, não com uma pedra.",
      "maxKingsCaptureTie": "Com o mesmo número de peças, é preciso fazer a sequência que come mais damas.",
      "firstKingFirst": "Se ainda houver empate, é preciso fazer a sequência que come uma dama o quanto antes.",
      "huffing": "Vale a regra do “sopro”: a peça que deixou de capturar pode ser retirada.",
      "captureImmediateRemoval": "Cada peça capturada sai do tabuleiro na hora, o que pode abrir novas capturas na mesma sequência.",
      "captureNoReversal": "Dentro de uma captura múltipla você pode seguir reto ou virar 90°, mas nunca voltar 180° entre dois saltos.",
      "promotionStops": "A pedra que chega à última fila vira dama e o lance acaba ali, mesmo no meio de uma captura.",
      "promotionContinues": "A pedra que atravessa a última fila no meio de uma captura continua pedra e segue capturando; só vira dama se o lance terminar na última fila.",
      "promotionInPassing": "A pedra que chega à última fila no meio de uma captura vira dama na hora e continua a captura como dama voadora no mesmo lance.",
      "blockedKing": "Enquanto um jogador ainda tiver pedras, não pode fazer mais de {{n}} lances simples consecutivos com a mesma dama; a dama bloqueada pode, no entanto, capturar.",
      "frisianEndgame": "Valem as regras frísias de empate nos finais (por exemplo, duas damas contra uma dá empate depois de um certo número de lances).",
      "loneKingWins": "Se um jogador ficar com uma pedra só contra a dama solitária do adversário, quem tem a dama é declarado vencedor.",
      "singlePieceLoses": "O jogador que ficar com uma peça só — pedra ou dama — perde a partida na hora.",
      "drawLimit": "A partida é empatada depois de {{n}} lances em que só as damas andam e nada é capturado."
    },
    "openings": {
      "title": "Tabelas de abertura",
      "heroSubtitle": "As 174 aberturas oficiais de {{variant}}, com o seu código de força e a tabela federal a que pertencem.",
      "source": "Fonte: Regolamento Tecnico F.I.D., janeiro de 2025.",
      "cta": "Tabelas de abertura",
      "ctaDesc": "As 174 aberturas oficiais e como elas são avaliadas.",
      "intro": "No jogo oficial os três primeiros meios-lances não são escolhidos, e sim sorteados numa tabela. A tabela geral traz todas as 174 aberturas; as tabelas federais A, B, C e D são subconjuntos dela, usados conforme o tipo de confronto.",
      "ratedNote": "Num desafio direto você pode limitar o sorteio pela força: até 2P/2B uma partida única ainda conta para o rating; acima disso é preciso um confronto de ida e volta.",
      "tableAll": "Geral",
      "tableA": "Tabela A",
      "tableB": "Tabela B",
      "tableC": "Tabela C",
      "tableD": "Tabela D",
      "count": "{{count}} aberturas",
      "colNumber": "Nº",
      "colOpening": "Abertura",
      "colStrength": "Força",
      "colStrengthShort": "For.",
      "colTables": "Tabelas",
      "colTablesShort": "Tab.",
      "firstMove": "Primeiro lance {{move}}",
      "legendTitle": "Como ler o código de força",
      "legendColours": "N = pretas (Nero), B = brancas (Bianco).",
      "legendPari": "PARI — jogo equilibrado.",
      "legend1": "1N / 1B — essa cor fica um pouco melhor, com mais escolha de linhas.",
      "legend2": "2N / 2B — essa cor fica claramente melhor e o adversário joga na defesa.",
      "legend3": "3N / 3B — essa cor fica temível: o adversário precisa jogar como especialista para empatar.",
      "legend4": "4N / 4B — essa cor é considerada vencedora com o conhecimento de hoje.",
      "tablesTitle": "As tabelas federais",
      "italianA": "Só para confrontos de ida e volta, duplas e provas por equipes.",
      "italianB": "Tabela padrão das provas oficiais; também serve para partida única.",
      "italianC": "Subconjunto da B para as categorias de base e provinciais e para torneios de promoção.",
      "italianD": "As aberturas consideradas vencedoras: só em confrontos de ida e volta.",
      "englishA": "A tabela usada normalmente em confrontos de ida e volta e em provas por equipes.",
      "englishB": "Torneios disputados em partida única.",
      "englishC": "Subconjunto da B para os casos especiais que o regulamento da prova permite.",
      "englishD": "As aberturas consideradas vencedoras: só em confrontos de ida e volta.",
      "tableEvery": "Todas",
      "everyTitle": "Por que 302 aberturas viram 174",
      "everyIntro": "Existem {{total}} aberturas legais de três meios-lances, mas elas só chegam a {{positions}} posições diferentes: a tabela geral escolhe {{listed}} delas, uma por posição. Veja o que acontece com o resto.",
      "status_ballot": "Listada",
      "statusBallotDesc": "Sorteável: é uma das aberturas oficiais.",
      "statusTransposition": "Igual à nº {{id}}",
      "statusTranspositionShort": "Transposição",
      "statusTranspositionDesc": "Mesma posição final de uma abertura já listada, alcançada jogando os lances em outra ordem: seria a mesma partida com outro nome.",
      "status_material": "Perde uma pedra",
      "statusMaterialDesc": "Depois do terceiro meio-lance um dos lados fica uma pedra atrás sem recaptura: são as duas combinações que o regulamento sempre excluiu.",
      "status_unlisted": "Não listada",
      "statusUnlistedDesc": "Uma posição que a tabela simplesmente não cobre. Não há razão mecânica: a federação selecionou as linhas que valem a pena estudar.",
      "statusDecidedDesc": "Continuam listadas, mas só para confrontos de ida e volta: são consideradas vencedoras para a cor favorecida e, portanto, perdedoras para a outra.",
      "colPosition": "Posição"
    },
    "capture": {
      "cta": "As regras de captura",
      "ctaDesc": "A precedência das capturas, passo a passo, com exemplos.",
      "title": "Regras de captura",
      "heroSubtitle": "Quando capturar é obrigatório, qual captura você tem de jogar e como ela é contada, em {{variant}}.",
      "intro": "A captura é a parte mais regulada do jogo. Saber capturar não basta: é preciso saber qual captura você é obrigado a jogar. Todas as regras estão aqui, na ordem exata em que o jogo as aplica.",
      "source": "Fonte: Regulamento Técnico da F.I.D., janeiro de 2025.",
      "mandatoryTitle": "Capturar é obrigatório",
      "mandatoryBody": "Se houver uma captura na sua vez, todos os lances tranquilos somem: não são lances ruins, eles simplesmente não existem. A obrigação vale para a posição inteira, não para uma peça só.",
      "mandatoryRejected": "Errar não tem punição: uma captura que quebra as regras é recusada e a posição fica como estava.",
      "geometryTitle": "Como funciona uma captura",
      "geometryShortKing": "A dama também salta uma casa só: a peça adversária precisa estar imediatamente ao lado dela na diagonal.",
      "geometryLanding": "A casa atrás da peça capturada precisa estar vazia. Se estiver ocupada, por qualquer peça que seja, ou fora do tabuleiro, essa captura não existe.",
      "menVsKingTitle": "Pedras e damas",
      "menVsKingWall": "Para uma pedra, a dama adversária é um muro: não dá para capturá-la nem saltar por cima dela. Uma dama colocada na frente de um grupo de peças deixa todas fora do alcance de qualquer pedra.",
      "menVsKingFree": "Não há restrição por categoria: qualquer peça pode capturar qualquer peça.",
      "multiTitle": "A captura múltipla",
      "multiBody": "Se depois de um salto a peça ficar diante de outra peça capturável, ela tem de seguir. Parar no meio não é uma escolha: uma sequência incompleta não é lance legal.",
      "multiDirection": "Dá para mudar de direção a cada salto. A pedra, porém, só alterna entre as suas duas diagonais para a frente: ela nunca ganha captura para trás durante a sequência.",
      "multiNoTwice": "A mesma peça adversária não pode ser saltada duas vezes na mesma sequência. Já a mesma casa vazia pode ser atravessada quantas vezes for preciso.",
      "ladderTitle": "Precedência de captura",
      "ladderIntro": "Quando há mais de uma captura disponível, a escolha não é sua. O jogo compara as capturas por estes critérios, nesta ordem: só passa ao critério seguinte quando o anterior deixa várias capturas empatadas.",
      "ladderWholePosition": "A comparação abrange todas as capturas de todas as suas peças. Uma peça pode, portanto, ficar presa porque outra peça tem uma captura melhor.",
      "ladderNoneIntro": "Capturar é obrigatório, mas qual captura jogar é inteiramente com você. Não há precedência nenhuma: uma captura simples vale tanto quanto uma múltipla, e nada obriga a comer mais.",
      "levelLabel": "Nível {{n}}",
      "levelMaxPieces": "Você tem de jogar a captura que come o maior número de peças.",
      "whyMaxPieces": "Contam-se as peças, não o valor delas: duas pedras ganham de uma dama.",
      "levelMaxValue": "Você tem de jogar a captura de maior valor total.",
      "whyMaxValue": "As damas pesam mais que as pedras, então a sequência mais longa nem sempre vence.",
      "levelWithKing": "Com o mesmo número de peças, é preciso capturar com uma dama, não com uma pedra.",
      "whyWithKing": "O critério olha para a peça que captura, não para a capturada. Se uma dama e uma pedra comem o mesmo número de peças, a dama é que tem de andar, mesmo quando a pedra comeria peças mais valiosas.",
      "levelMaxKings": "Continuando empatado, é preciso jogar a captura que come o maior número de damas.",
      "whyMaxKings": "Aqui o que importa é o valor do que você tira. Como só damas capturam damas, este critério só chega a separar capturas feitas por uma dama.",
      "levelFirstKing": "Continuando empatado, é preciso escolher a sequência que come uma dama o quanto antes.",
      "whyFirstKing": "Olha-se a ordem dos saltos: entre dois caminhos que comem as mesmas peças, vence o que encontra a dama no salto mais cedo.",
      "levelFree": "Se as capturas continuarem equivalentes, a escolha é livre.",
      "whyFree": "Daí em diante nenhuma regra prende o jogador: duas capturas iguais em todos os critérios podem ser jogadas indiferentemente.",
      "removalTitle": "Quando as peças saem",
      "removalEnd": "As peças capturadas ficam no tabuleiro até o lance acabar e saem todas juntas quando a sequência termina. É por isso que você ainda as vê no lugar durante uma captura múltipla.",
      "removalImmediate": "A casa que vagou fica disponível na hora. Saltar duas vezes a mesma peça continua proibido.",
      "promotionTitle": "A promoção encerra a captura",
      "promotionBody": "Se uma pedra chegar à última fila durante uma sequência, o lance acaba ali: a pedra vira dama e a vez passa, mesmo que houvesse mais saltos possíveis a partir daquela casa. A dama nova só anda a partir do lance seguinte.",
      "promotionNoExemption": "A promoção não dá isenção da precedência: a sequência interrompida é comparada pelas peças que realmente comeu. Se outra captura comer mais, a que promove é ilegal.",
      "promotionStillAMan": "Para a precedência, a pedra que promove continua contando como pedra: ela não ganha a prioridade de dama.",
      "noHuffingTitle": "Nada de sopro",
      "noHuffingBody": "A regra do “sopro” não vale: quem deixa passar uma captura obrigatória não perde a peça, simplesmente não pode fazer aquele lance.",
      "exGeometry": "As brancas saltam a peça vizinha e caem logo atrás dela.",
      "exMenVsKingWall": "A pedra está ao lado de uma dama adversária e não pode comê-la: só resta um lance tranquilo.",
      "exMenVsKingFree": "Aqui a pedra come a dama como comeria qualquer outra peça.",
      "exMulti": "Um único lance legal: a sequência tem de ser jogada até o fim.",
      "exPromotion": "As brancas chegam à última fila, então o lance acaba ali — mesmo com uma peça ainda por comer.",
      "exMaxPieces": "Duas capturas disponíveis: uma come uma peça, a outra come duas. Só a mais longa é legal.",
      "exMaxValue": "Entre as capturas disponíveis, decide o valor total das peças comidas.",
      "exWithKing": "A dama e a pedra comem uma peça cada: é a dama que tem de andar.",
      "exMaxKings": "Duas damas podem capturar: é a dama adversária que tem de ser comida, não a pedra.",
      "exFirstKing": "Dois caminhos de duas peças com uma dama cada: é obrigatório o que come a dama primeiro.",
      "exFree": "O mesmo circuito, nos dois sentidos, come as mesmas quatro peças: você escolhe.",
      "exFreeNoLadder": "Uma captura come uma peça, a outra come duas: aqui as duas são legais.",
      "forced": "Lance obrigatório",
      "choices": "Lances legais",
      "diagramAlt": "Posição de exemplo"
    },
    "gameRulesHead": "Regras do jogo"
  },
  "faq": {
    "title": "Dúvidas e contato",
    "intro": "Perguntas frequentes e um canal direto para problemas, pedidos e sugestões.",
    "questionsTitle": "Perguntas frequentes",
    "entries": [
      {
        "id": "install-android",
        "q": "Como instalo o aplicativo no Android?",
        "a": "O aplicativo se instala direto pelo navegador — não precisa da Play Store.\n1. Abra o site no Chrome (ou Edge, Samsung Internet).\n2. Toque no menu ⋮ no canto superior direito.\n3. Escolha \"Instalar aplicativo\" (ou \"Adicionar à tela inicial\") e confirme.\nAlguns navegadores também mostram sozinhos um aviso de instalação — pode usar esse. O ícone aparece junto dos seus outros aplicativos e o jogo abre em tela cheia, sem a barra do navegador."
      },
      {
        "id": "install-ios",
        "q": "Como instalo o aplicativo no iPhone ou iPad?",
        "a": "No iPhone e no iPad os passos são diferentes e precisam ser feitos no Safari.\n1. Abra o site no Safari (em outros navegadores a opção pode não aparecer).\n2. Toque no botão Compartilhar (o quadrado com uma seta para cima): embaixo no iPhone, em cima no iPad.\n3. Role a lista e escolha \"Adicionar à Tela de Início\".\n4. Toque em \"Adicionar\" no canto superior direito.\nO iOS nunca mostra um aviso de instalação automático, então sem esses passos nenhum ícone é criado."
      },
      {
        "id": "install-desktop",
        "q": "Dá para instalar o aplicativo no computador?",
        "a": "Dá, com o Chrome ou o Edge.\n1. Abra o site.\n2. Clique no ícone de instalação do lado direito da barra de endereços, ou abra o menu do navegador e escolha \"Instalar…\".\n3. Confirme: o aplicativo abre em uma janela própria, sem a barra do navegador.\nO Firefox e o Safari no computador não suportam instalar aplicativos web — você continua jogando normalmente no navegador e pode salvar o site nos favoritos."
      },
      {
        "id": "login",
        "q": "Não consigo entrar na minha conta — o que faço?",
        "a": "Confira se o e-mail e a senha estão certos. Se esqueceu a senha, use o link \"Esqueci a senha\" na tela de entrada. Se o problema continuar, preencha o formulário de contato abaixo e escolha a categoria \"Problema para entrar\"."
      },
      {
        "id": "verify-email",
        "q": "Nunca recebi o e-mail de verificação — como consigo de novo?",
        "a": "Abra a janela de entrada, tente entrar com os seus dados e clique no botão \"Reenviar e-mail de verificação\". Não esqueça de olhar a pasta de spam."
      },
      {
        "id": "variant-request",
        "q": "Posso sugerir uma nova variante de damas?",
        "a": "Pode! Preencha o formulário de contato abaixo, escolha \"Pedido de nova variante\" e descreva as regras da variante que gostaria de ver aqui."
      },
      {
        "id": "rules-wrong",
        "q": "As regras de uma variante parecem erradas — como aviso?",
        "a": "Preencha o formulário de contato abaixo e escolha \"Correção de regras\". Diga qual variante está envolvida e descreva a regra que precisa ser corrigida, de preferência com um link para a fonte oficial (FMJD, FID, WCDF etc.)."
      },
      {
        "id": "delete-account",
        "q": "Como excluo a minha conta?",
        "a": "Abra as configurações do seu perfil: lá estão as opções de exportar os seus dados (LGPD/GDPR) e de excluir a conta em definitivo. A exclusão é irreversível."
      }
    ],
    "contactTitle": "Fale com a gente",
    "contactIntro": "Não achou a sua resposta? Escreva para nós e respondemos por e-mail.",
    "category": {
      "login": "Problema para entrar",
      "variant_request": "Pedido de nova variante",
      "rules": "Correção de regras",
      "other": "Outro"
    },
    "fields": {
      "name": "Nome (opcional)",
      "email": "E-mail",
      "category": "Categoria",
      "subject": "Assunto",
      "message": "Mensagem"
    },
    "submit": "Enviar pedido",
    "success": "Obrigado! O seu pedido foi enviado. Respondemos por e-mail assim que possível.",
    "errors": {
      "invalidEmail": "Digite um endereço de e-mail válido.",
      "subjectTooShort": "O assunto precisa ter pelo menos 3 caracteres.",
      "messageTooShort": "A mensagem precisa ter pelo menos 10 caracteres.",
      "rateLimited": "Você enviou pedidos demais nos últimos minutos. Tente de novo daqui a uma hora.",
      "submitFailed": "Não foi possível enviar. Verifique a sua conexão e tente de novo."
    }
  },
  "home": {
    "heroTitle": "Damas Online",
    "heroTagline": "A plataforma das damas internacionais, italianas e inglesas. Jogue, dispute torneios e suba no ranking.",
    "welcome": "Bem-vindo",
    "newGame": "Nova partida",
    "chooseMode": "Escolha o seu modo de jogo",
    "startNow": "Jogar",
    "vsAI": "Jogar contra a IA",
    "vsAIDesc": "Treine contra o computador",
    "vsOnline": "Jogar online",
    "vsOnlineDesc": "Desafie jogadores de verdade",
    "vsFriends": "Jogar com amigos",
    "vsFriendsDesc": "Crie ou entre em uma partida privada",
    "createTable": "Criar mesa",
    "createTableDesc": "Convide um amigo para jogar",
    "joinTable": "Entrar na mesa",
    "joinTableDesc": "Digite um código de sala",
    "enterRoomCode": "Digite o código de sala que o seu amigo mandou",
    "variant": "Variante",
    "difficulty": "Dificuldade",
    "timeControl": "Ritmo",
    "startGame": "Começar a partida",
    "playersOnline": "jogadores online",
    "gamesInProgress": "partidas em andamento",
    "landing": {
      "heroTitle": "Jogue damas",
      "heroTitleAccent": "Online",
      "heroTagline": "Variantes de damas do mundo inteiro. Torneios, partidas valendo rating, adversários de IA — jogue agora.",
      "playFree": "Jogar agora",
      "signUp": "Cadastrar",
      "playAsGuest": "Jogar como convidado",
      "featuresLabel": "Por que damas?",
      "featuresTitle": "Tudo o que você precisa para jogar",
      "featuresSubtitle": "Uma plataforma completa, feita tanto para quem compete quanto para quem joga por prazer.",
      "featureTournaments": "Torneios",
      "featureTournamentsDesc": "Formatos suíço e arena com pareamento automático, rating Glicko-2 e classificação em tempo real.",
      "featureRating": "Sistema de rating",
      "featureRatingDesc": "Ratings Glicko-2 separados por variante e por ritmo. Acompanhe a sua evolução ao longo do tempo.",
      "featureAI": "Adversários de IA",
      "featureAIDesc": "6 níveis de dificuldade, do iniciante ao mestre. Treine a qualquer hora, sem esperar por ninguém.",
      "featureVariants": "Variantes do mundo",
      "featureVariantsDesc": "Da internacional e da italiana à turca, à frísia e a muitas outras — variantes de damas do mundo inteiro.",
      "featureOnline": "Jogo online",
      "featureOnlineDesc": "Ache um adversário em segundos com o pareamento e jogue valendo rating ou por prazer.",
      "featurePuzzles": "Problemas diários",
      "featurePuzzlesDesc": "Um problema novo por dia em várias variantes. Afie a sua tática e faça o rating subir.",
      "specBoard": "Tabuleiro {{size}}",
      "specPieces": "{{count}} peças de cada lado",
      "specFlyingKings": "Damas que voam",
      "specShortKings": "Damas de alcance curto",
      "howLabel": "Como?",
      "howTitle": "Comece a jogar em segundos",
      "step1Title": "Crie uma conta",
      "step1Desc": "Cadastre-se em segundos. Ou jogue na hora como convidado.",
      "step2Title": "Escolha a sua partida",
      "step2Desc": "Escolha a variante, o ritmo e jogue contra gente ou contra a IA.",
      "step3Title": "Suba na classificação",
      "step3Desc": "Vença partidas, ganhe pontos de rating e dispute torneios diários.",
      "variantsLabel": "Variantes de jogo",
      "variantsTitle": "Todas as variantes das damas, numa plataforma só",
      "variantsMoreTitle": "E muitas outras variantes",
      "variantsAllCta": "Ver as regras de todas as variantes",
      "intlBadge": "Oficial FMJD",
      "intlDesc": "O padrão das damas de competição no mundo inteiro. Damas que voam, captura obrigatória e regra da captura mais longa.",
      "italianBadge": "Tradicional",
      "italianDesc": "A querida tradição italiana. As pedras não capturam damas, e a regra da maior captura cria um jogo tático profundo.",
      "englishBadge": "Oficial WCDF",
      "englishDesc": "Damas clássicas 8×8 jogadas no mundo inteiro. Captura obrigatória, damas que não voam, pedras que capturam damas e nenhum movimento para trás com pedras.",
      "brazilianBadge": "Popular",
      "brazilianDesc": "A variante de damas preferida do Brasil. Tabuleiro 8×8 com damas que voam, captura mais longa obrigatória e pedras que capturam para trás.",
      "ctaTitle": "Pronto para jogar?",
      "ctaSubtitle": "Entre para a comunidade. Comece a sua primeira partida.",
      "ctaButton": "Começar a jogar agora",
      "heroCta": "Jogar agora",
      "puzzleTitle": "Experimente um problema",
      "puzzleSubtitle": "Resolva esta posição agora mesmo — sem precisar se cadastrar. Depois crie uma conta grátis para jogar o problema do dia e fazer o seu rating subir."
    },
    "dashboard": {
      "welcomeBack": "Bem-vindo de volta",
      "recentGames": "Partidas recentes",
      "viewAll": "Ver tudo",
      "liveUpcoming": "Ao vivo e em breve",
      "allTournaments": "Todos os torneios",
      "thisWeek": "esta semana",
      "live": "AO VIVO",
      "join": "Entrar",
      "noRecentGames": "Nenhuma partida ainda. Jogue a sua primeira!",
      "noTournaments": "Nenhum torneio chegando.",
      "dailyPuzzle": {
        "title": "Problema do dia",
        "whiteToMove": "Brancas jogam",
        "blackToMove": "Pretas jogam"
      },
      "timeAgo": {
        "now": "agora mesmo",
        "minutes": "há {{count}} min",
        "hours": "há {{count}}h",
        "yesterday": "Ontem",
        "days": "há {{count}}d",
        "weeks": "há {{count}}sem",
        "months": "há {{count}}mes"
      }
    }
  },
  "game": {
    "header": {
      "rated": "Valendo rating",
      "casual": "Amistosa",
      "variantRules": "Regras da variante"
    },
    "variants": {
      "international": "Damas Internacionais 10×10",
      "internationalShort": "Internacional 10×10",
      "internationalMedium": "Internacional 10×10",
      "italian": "Damas Italianas 8×8",
      "italianShort": "Italiana 8×8",
      "english": "Damas Inglesas 8×8",
      "englishShort": "Inglesa 8×8",
      "englishBadge": "Oficial WCDF",
      "englishDesc": "Damas clássicas 8×8 jogadas no mundo inteiro. Captura obrigatória, damas que não voam, pedras que capturam damas e nenhum movimento para trás com pedras.",
      "brazilian": "Damas Brasileiras 8×8",
      "brazilianShort": "Brasileira 8×8",
      "frisian": "Damas Frísias 10×10",
      "frisianShort": "Frísia 10×10",
      "frysk": "Frysk! 10×10",
      "fryskShort": "Frysk 10×10",
      "turkish": "Damas Turcas 8×8",
      "turkishShort": "Turca 8×8",
      "armenian": "Tama Armênio 8×8",
      "armenianShort": "Armênio 8×8",
      "russian": "Damas Russas 8×8",
      "russianShort": "Russa 8×8",
      "spanish": "Damas Espanholas 8×8",
      "spanishShort": "Espanhola 8×8",
      "triestine": "Damas Triestinas 10×10",
      "triestineShort": "Triestina 10×10",
      "canadian": "Damas Canadenses 12×12",
      "canadianShort": "Canadense 12×12",
      "nigerian": "Damas Nigerianas 10×10",
      "nigerianShort": "Nigeriana 10×10",
      "ghanaian": "Damas Ganesas 10×10",
      "ghanaianShort": "Ganesa 10×10",
      "pool": "Pool Checkers 8×8",
      "poolShort": "Pool 8×8",
      "czech": "Damas Tchecas 8×8",
      "czechShort": "Tcheca 8×8",
      "thai": "Makhos Tailandês 8×8",
      "thaiShort": "Tailandês 8×8",
      "portuguese": "Damas Portuguesas 8×8",
      "portugueseShort": "Portuguesa 8×8",
      "filipino": "Damas Filipinas 8×8",
      "filipinoShort": "Filipina 8×8",
      "malaysian": "Damas Malaias 12×12",
      "malaysianShort": "Malaia 12×12",
      "german": "Damas Alemãs 8×8",
      "germanShort": "Alemã 8×8",
      "jamaican": "Damas Jamaicanas 8×8",
      "jamaicanShort": "Jamaicana 8×8",
      "sinhalese": "Damas Cingalesas 8×8",
      "sinhaleseShort": "Cingalesa 8×8",
      "south_african": "Damas Sul-Africanas 14×14",
      "south_africanShort": "Sul-Afr. 14×14",
      "dameo": "Dameo 8×8",
      "dameoShort": "Dameo 8×8",
      "croda": "Croda 8×8",
      "crodaShort": "Croda 8×8"
    },
    "opponent": {
      "computer": "IA"
    },
    "modes": {
      "twoPlayers": "2 jogadores",
      "aiVeryEasy": "Muito fácil",
      "aiEasy": "Fácil",
      "aiMedium": "Média",
      "aiHard": "Difícil",
      "aiExpert": "Muito difícil",
      "aiMaster": "Mestre",
      "playOnline": "Jogar online"
    },
    "timeControls": {
      "noTimeLimit": "Sem limite de tempo",
      "blitz30": "Blitz 3+0",
      "blitz32": "Blitz 3+2",
      "blitz50": "Blitz 5+0",
      "blitz53": "Blitz 5+3",
      "rapid105": "Rápida 10+5",
      "rapid1510": "Rápida 15+10"
    },
    "turn": {
      "yourTurn": "Sua vez",
      "opponentTurn": "Vez do adversário",
      "toMove": "Joga",
      "aiThinking": "A IA está pensando...",
      "aiTurn": "Vez da IA",
      "aiDeclinedDraw": "O computador recusou o empate",
      "whiteToMove": "Brancas jogam",
      "blackToMove": "Pretas jogam"
    },
    "result": {
      "youWin": "Você venceu!",
      "youLose": "Você perdeu!",
      "draw": "Empate!",
      "whiteWins": "Brancas vencem!",
      "blackWins": "Pretas vencem!",
      "gameOver": "Fim de partida",
      "gameAbandoned": "Partida abandonada",
      "noWinner": "Partida encerrada",
      "won": "Vitória",
      "lost": "Derrota"
    },
    "drawCountdown": {
      "aria_one": "Empate automático em {{count}} lance se só as damas andarem",
      "aria_other": "Empate automático em {{count}} lances se só as damas andarem"
    },
    "frisianCountdown": {
      "aria_one": "Empate automático em {{count}} lance: duas damas contra uma",
      "aria_other": "Empate automático em {{count}} lances: duas damas contra uma"
    },
    "endReason": {
      "checkmate": "sem lances possíveis",
      "noLegalMoves": "não tem mais nenhum lance legal.",
      "whiteNoMoves": "As brancas não têm mais nenhum lance legal.",
      "blackNoMoves": "As pretas não têm mais nenhum lance legal.",
      "drawEnded": "A partida terminou empatada.",
      "gameAbandoned": "A partida foi abandonada.",
      "noWinner": "A partida terminou sem vencedor.",
      "gameEnded": "A partida terminou.",
      "resignation": "desistência",
      "disconnection": "queda de conexão",
      "fiftyMoves": "regra dos cinquenta lances",
      "timeout": "tempo esgotado",
      "agreement": "empate por acordo",
      "walkover": "vitória sem jogo",
      "firstKing": "Primeira dama",
      "sideResigned": "{{side}} desistiu.",
      "sideTimeout": "O tempo de {{side}} acabou.",
      "sideNoPieces": "{{side}} ficou sem peças.",
      "moveLimit": "Lances demais sem nenhuma captura.",
      "repetition": "A mesma posição se repetiu três vezes.",
      "endgameDraw": "Final teoricamente empatado.",
      "sideZugzwang": "{{side}} está em zugzwang: todo lance perde.",
      "loneKing": "Uma dama sozinha ganha de uma pedra sozinha.",
      "sideSinglePiece": "{{side}} ficou com uma peça só.",
      "drawAgreed": "Empate por acordo.",
      "sideNoFirstMove": "{{side}} não jogou a tempo.",
      "noFirstMove": "Primeiro lance não jogado a tempo."
    },
    "actions": {
      "newGame": "Nova partida",
      "resign": "Desistir",
      "endGame": "Encerrar",
      "leaveGame": "Sair da partida",
      "backToLobby": "Voltar ao saguão",
      "offerDraw": "Empate",
      "drawOffered": "O seu adversário propõe empate",
      "drawSent": "Empate proposto…",
      "acceptDraw": "Aceitar",
      "declineDraw": "Recusar",
      "drawDeclined": "O seu adversário recusou o empate",
      "drawMoveFirst": "Jogue primeiro",
      "drawMustMoveFirst": "Faça um lance antes de propor empate de novo.",
      "drawNoneLeft": "Sem propostas",
      "drawLimitReached": "Você usou todas as suas propostas de empate nesta partida.",
      "drawTooFast": "Muitas propostas de empate. Espere um instante.",
      "requestTakeback": "Voltar lance",
      "takebackRequested": "Pedido de voltar o lance enviado…",
      "opponentRequestsTakeback_one": "O adversário pede para voltar {{count}} lance",
      "opponentRequestsTakeback_other": "O adversário pede para voltar {{count}} lances",
      "acceptTakeback": "Aceitar",
      "declineTakeback": "Recusar",
      "takebackDeclined": "O seu pedido de voltar o lance foi recusado",
      "takebackAccepted": "O seu pedido de voltar o lance foi aceito",
      "takebackDisabledRated": "Voltar lances está desativado em partidas valendo rating",
      "focus": "Foco",
      "focusExit": "Sair",
      "peek": "Espiar",
      "boardSize": "Tamanho do tabuleiro",
      "boardBigger": "Tabuleiro maior",
      "boardSmaller": "Tabuleiro menor",
      "flipBoard": "Girar"
    },
    "confirmLeave": "Tem certeza de que quer sair da partida?",
    "confirmLeaveTitle": "Sair da partida?",
    "confirmLeaveCancel": "Cancelar",
    "confirmLeaveButton": "Sair",
    "confirmResignTitle": "Desistir?",
    "confirmResign": "Tem certeza de que quer desistir? Você vai perder a partida.",
    "confirmEndGameTitle": "Encerrar a partida?",
    "confirmEndGame": "A partida terminará sem vencedor.",
    "clock": {
      "white": "Brancas",
      "black": "Pretas"
    },
    "aborted": {
      "opponentLeft": "O seu adversário saiu antes de a partida começar — procurando outro para você…",
      "opponentDidNotMove": "Seu adversário não jogou a tempo — partida anulada."
    },
    "disconnection": {
      "opponentDisconnected": "Adversário desconectado",
      "waitingToReconnect": "Esperando o adversário reconectar...",
      "opponentLeft": "O adversário saiu da partida",
      "disconnected": "Desconectado",
      "notPresent": "Ausente",
      "avvisoMaiArrivato": "Adversário ainda não chegou: se não chegar, você vence quando o relógio dele acabar.",
      "avvisoDecideOrologio": "Adversário desconectado: se não voltar, você vence quando o relógio dele acabar.",
      "avvisoGrazia": "Adversário desconectado: se não voltar em {{secondi}} s, você vence.",
      "avvisoMaiArrivatoTuoTurno": "Adversário ainda não chegou: faça sua jogada; se ele não chegar, você vence quando o relógio dele acabar.",
      "avvisoDecideOrologioTuoTurno": "Adversário desconectado: faça sua jogada; se ele não voltar, você vence quando o relógio dele acabar."
    },
    "sidebar": {
      "moves": "Lances",
      "openingNumbered": "Abertura n.º {{n}}",
      "openingDrawn": "Abertura sorteada",
      "chat": "Chat",
      "spectators": "Espectadores",
      "noMoves": "Nenhum lance ainda",
      "viewMove": "Ver a posição depois do lance {{n}}",
      "goToStart": "Ir para o início",
      "prevMove": "Lance anterior",
      "nextMove": "Próximo lance",
      "goLive": "Ir para a posição atual",
      "play": "Reproduzir",
      "pause": "Pausar",
      "position": "Posição na linha",
      "showMoves": "Mostrar os lances",
      "hideMoves": "Ocultar os lances"
    },
    "blind": {
      "lastMove": "Último lance",
      "promoted": "Virou dama",
      "noPeeks": "Jogada sem espiar nenhuma vez.",
      "peeks_one": "Você espiou {{count}} vez.",
      "peeks_other": "Você espiou {{count}} vezes."
    },
    "confirmDrawTitle": "Empate?",
    "confirmDraw": "Terminar a partida empatada? Os dois jogadores precisam concordar.",
    "match": {
      "playReturn": "Jogar a partida de volta"
    },
    "primaMossa": {
      "secondi_one": "{{count}}s",
      "secondi_other": "{{count}}s",
      "ariaVoid_one": "Primeiro lance em {{count}} segundo, ou a partida é anulada",
      "ariaVoid_other": "Primeiro lance em {{count}} segundos, ou a partida é anulada",
      "ariaForfeit_one": "Primeiro lance em {{count}} segundo, ou você perde por W.O.",
      "ariaForfeit_other": "Primeiro lance em {{count}} segundos, ou você perde por W.O."
    },
    "saluto": {
      "invia": "Deseje um bom jogo ao seu adversário",
      "mittente": "{{username}}:",
      "ancheATe": "Igualmente",
      "inviato": "Cumprimento enviado"
    }
  },
  "online": {
    "title": "Jogo online",
    "playOnline": "Jogar online",
    "connecting": "Conectando ao servidor...",
    "connectionFailed": "Falha na conexão",
    "couldNotConnect": "Não foi possível conectar ao servidor de jogo.",
    "error": "Erro",
    "room": {
      "title": "Sala",
      "code": "Código da sala",
      "shareCode": "Compartilhe este código de sala:",
      "playAs": "Você joga de",
      "waitingForOpponent": "Esperando um adversário"
    },
    "lobby": {
      "findMatch": "Procurar partida",
      "matchmakingByRating": "Pareamento automático por rating",
      "signInToMatch": "Entre para usar o pareamento automático com rating",
      "createGame": "Criar uma partida",
      "selectVariantAndTime": "Escolha a variante e o ritmo",
      "createRoom": "Criar sala",
      "joinGame": "Entrar numa partida",
      "enterRoomCode": "Digite um código de sala para entrar",
      "join": "Entrar",
      "playWithFriends": "ou jogue com amigos"
    },
    "matchmaking": {
      "findingOpponent": "Procurando adversário...",
      "matchingSimilarSkill": "Procurando um jogador de nível parecido com o seu...",
      "creatingRoom": "Criando a sala...",
      "joiningRoom": "Entrando na sala...",
      "estimatedWait": "Espera estimada: ~{{seconds}}s",
      "timeout": "Nenhum adversário encontrado. Tente de novo."
    },
    "errors": {
      "authRequired": "Você precisa estar conectado para jogar online.",
      "alreadyInQueue": "Você já está procurando uma partida.",
      "alreadyInGame": "Você já está em uma partida.",
      "generico": "Algo deu errado. Tente de novo.",
      "nonConnesso": "Você não está conectado ao servidor.",
      "partitaSparita": "Esta partida não existe mais.",
      "drawOfferFailed": "Não foi possível propor empate.",
      "serverRestart": "O servidor está reiniciando: a partida volta em instantes. Se não voltar, recarregue a página.",
      "sfidaTroppeRichieste": "Você enviou desafios demais seguidos. Espere um momento.",
      "avversarioOffline": "Este jogador ficou offline.",
      "avversarioInPartita": "Este jogador já está em uma partida. Tente quando ele terminar.",
      "seiInGara": "Você está em um torneio ou arena em andamento: termine aquilo primeiro.",
      "avversarioInGara": "Este jogador está jogando um torneio ou uma arena.",
      "troppePosizioni": "Posições personalizadas demais seguidas. Espere um momento.",
      "impostazioniNonValide": "Estas configurações não são válidas. Confira e tente de novo.",
      "soloIscritti": "Este jogador só pode jogar partidas amistosas.",
      "sfidaGiaInVolo": "Você já tem um desafio esperando resposta. Cancele antes.",
      "sfidaGiaMandata": "Você já desafiou este jogador: espere a resposta."
    },
    "challenge": {
      "challenge": "Desafiar",
      "sendChallenge": "Desafio direto",
      "incomingChallenge": "Desafio recebido",
      "tabBadge": "Desafio!",
      "send": "Enviar",
      "accept": "Aceitar",
      "decline": "Recusar",
      "cancel": "Cancelar",
      "loginRequired": "Entre para ver os jogadores online e mandar desafios",
      "waitingForResponse": "Esperando {{username}}...",
      "declined": "Desafio recusado",
      "expired": "Desafio expirado",
      "cancelled": "Desafio cancelado",
      "color": "Cor",
      "gameType": "Tipo de partida",
      "colorRandom": "Sorteada",
      "rated": "Valendo rating (sem convidados)",
      "casual": "Amistosa",
      "gameTypeAny": "Rating/Amistosa",
      "registeredOnly": "Só cadastrados",
      "registeredOnlyNote": "Só jogadores cadastrados podem jogar esta partida.",
      "opponentGuestNoRated": "Este adversário é convidado: a partida não pode valer rating.",
      "mode": "Modo",
      "modeNormal": "Padrão",
      "modeBreakthrough": "Rompimento",
      "modeAntidraughts": "Damas ao contrário",
      "modeBlind": "Às cegas",
      "modeInfoLabel": "Sobre os modos de jogo",
      "modeBreakthroughInfo": "Quem promover primeiro uma pedra a dama vence na hora.",
      "modeAntidraughtsInfo": "Misère: ganha quem perde — o primeiro a ficar sem peças, ou sem lances legais.",
      "modeBlindInfo": "As peças ficam invisíveis: você joga de memória, como se estivesse vendado. As regras são as normais.",
      "opening": "Abertura",
      "legs": "Partidas",
      "legsOne": "Partida única",
      "legsTwo": "Ida e volta",
      "openingDrawnSingleLegCasual": "Com esta abertura uma partida única não compensa a vantagem sorteada: a partida é sempre amistosa.",
      "time": "Tempo",
      "increment": "Acréscimo",
      "noClockCasual": "Partidas sem limite de tempo são sempre amistosas.",
      "link": {
        "inviteFriend": "Convidar um amigo",
        "title": "Desafiar um amigo",
        "intro": "Mande este link para quem quiser: a primeira pessoa que abrir joga com você, sem precisar de conta.",
        "share": "Compartilhar",
        "copy": "Copiar link",
        "copied": "Copiado!",
        "copyFailed": "Não foi possível copiar o link. Selecione-o e copie na mão.",
        "expiresIn": "O link ainda vale por {{time}}.",
        "startingSoon": "A partida está para começar...",
        "friendAccepted": "{{name}} aceitou o seu desafio!",
        "cancelLink": "Cancelar o desafio",
        "shareTitle": "Desafio de damas",
        "shareText": "Vem jogar damas comigo!",
        "shareTextWith": "Vem jogar damas comigo — {{summary}}",
        "challengesYou": "{{name}} desafia você para uma partida de damas",
        "playNow": "Jogar agora",
        "haveAccount": "Já tenho uma conta",
        "guestCasualNote": "Jogar como convidado torna esta partida amistosa (não mexe nos ratings).",
        "waitingChallengerTitle": "Desafio aceito",
        "waitingChallenger": "Esperando {{name}} voltar a ficar online. A partida começa sozinha.",
        "unavailableTitle": "Desafio indisponível",
        "cancelledByChallenger": "Quem desafiou você cancelou a partida.",
        "expiredOrGone": "Este link expirou ou não vale mais. Peça um novo ao seu amigo.",
        "backHome": "Voltar ao início"
      },
      "opening_free": "Lance livre",
      "opening_random1": "1 lance sorteado",
      "opening_random2": "2 lances sorteados",
      "opening_random3": "3 lances sorteados",
      "opening_ballot1": "Tabela C - 1P/1B",
      "opening_ballot2": "Tabela B - 2P/2B",
      "opening_ballot3": "Tabela {{tables}} - 3P/3B",
      "opening_ballot4": "Tabela geral",
      "opening_single": "Abertura fixa",
      "openingInfoLabel": "Sobre as aberturas",
      "openingInfo": "As opções “Tabela” sorteiam das tabelas oficiais da F.I.D.: o número entre parênteses é de quantas aberturas o sorteio tira, e o limite (1P/1B … 4P/4B) restringe o quanto ele pode ficar desequilibrado. Até a Tabela B uma partida única ainda conta para o rating; acima disso é preciso um confronto de ida e volta. Já as opções de “lances sorteados” tiram de todos os lances legais, sem limite nenhum: de 2 lances em diante exigem confronto de ida e volta.",
      "openingInfoRandom": "Os primeiros meios-lances são sorteados entre todos os lances legais: o número entre parênteses é quantas combinações diferentes podem sair. Esta variante não tem tabelas de abertura oficiais. De 2 lances em diante o sorteio pode favorecer uma cor, então a partida só conta para o rating como confronto de ida e volta.",
      "openingTablesLink": "Ver as tabelas de abertura",
      "guestCannotChallenge": "Os desafios diretos são para jogadores cadastrados. Entre ou crie uma conta grátis para mandá-los.",
      "guestCasualInvite": "Entre ou crie uma conta grátis para jogar partidas valendo rating.",
      "changeOpponent": "Trocar",
      "challengePlayer": "Desafiar {{username}}",
      "tableOpen": {
        "title": "{{username}} já tem uma mesa aberta",
        "other": "Enviar um desafio diferente"
      }
    },
    "status": {
      "playing": "Jogando",
      "playingWith": "Jogando contra {{username}}",
      "waiting": "Aguardando",
      "away": "Ausente",
      "busy": "Ocupado"
    },
    "chooseOpponent": "Escolha quem desafiar",
    "ratingsBucket": "Pontuações:",
    "onlinePlayers": "Jogadores online",
    "loadingPlayers": "Carregando jogadores...",
    "noPlayersOnline": "Ninguém mais está online neste momento",
    "reloadIn": "Recarregando em {{seconds}} s",
    "reloadInShort": "{{seconds}} s",
    "rematch": {
      "rematch": "Revanche",
      "accept": "Aceitar",
      "decline": "Recusar",
      "sessionScore": "Placar",
      "opponentWantsRematch": "O adversário quer revanche!",
      "declined": "O seu adversário recusou a revanche",
      "expired": "A oferta de revanche expirou",
      "invite": {
        "incoming": "Convite de revanche",
        "tabBadge": "Revanche!",
        "message": "<b>{{name}}</b> ({{rating}}) quer revanche · <b>{{timeControl}}</b> · {{variant}}",
        "messageNoRating": "<b>{{name}}</b> quer revanche · <b>{{timeControl}}</b> · {{variant}}"
      },
      "waitingForOpponent": "Esperando o adversário...",
      "newOpponent": "Voltar ao início"
    },
    "match": {
      "legFirst": "Partida de ida",
      "legSecond": "Partida de volta",
      "legOf": "Partida {{leg}} de {{total}}",
      "legShort": "{{leg}}/{{total}}",
      "score": "Confronto",
      "returnStartsIn": "A partida de volta começa em {{seconds}}s",
      "leavingForfeits": "Sair agora entrega a partida de volta.",
      "ratingAtMatchEnd": "O seu rating é atualizado no fim do confronto.",
      "ready": "Pronto",
      "opponentReady": "O seu adversário está pronto",
      "waitingOpponent": "Esperando o seu adversário...",
      "complete": "Confronto encerrado",
      "newMatch": "Novo confronto",
      "twoLegsShort": "2 partidas"
    },
    "connectedCount": "{{count}} Online",
    "viewProfile": "Perfil",
    "connessionePersa": {
      "titolo": "Conexão perdida",
      "corpo": "Tentando levar você de volta ao tabuleiro.",
      "riprova": "Tentar de novo",
      "esci": "Sair"
    },
    "partitaFinitaMentreEriVia": "A partida terminou enquanto você estava fora.",
    "sessioneAltrove": {
      "titolo": "Aberto em outro dispositivo",
      "corpo": "Você abriu o jogo em outro lugar: aqui você não recebe mais lances nem desafios.",
      "usaQui": "Usar aqui"
    }
  },
  "lobby": {
    "title": "Jogar",
    "quickPlay": "Partida rápida",
    "customGame": "Partida personalizada",
    "opponent": "Adversário",
    "opponentOnline": "Online (aleatório)",
    "opponentInPerson": "Presencial",
    "startInPerson": "Começar a partida",
    "inPersonNote": "Dois jogadores no mesmo aparelho. Não conta para o seu rating.",
    "openTable": "Abrir a mesa",
    "openTables": "Mesas à espera",
    "noTablesInVariant": "Nenhuma mesa em {{variant}} neste momento. Escolha uma cadência para abrir a sua.",
    "noTablesInVariantOrOther": "Nenhuma mesa em {{variant}} neste momento. Escolha uma cadência para abrir a sua ou sente-se em uma de outra variante:",
    "otherVariants": "Outras variantes",
    "sit": "Sentar",
    "cancelTable": "Cancelar",
    "waitingAtTable": "À espera de um adversário",
    "inQueue": "Na fila",
    "tableExpired": "A sua mesa expirou depois de 10 minutos sem adversário. Abra outra quando quiser.",
    "customPosition": "Posição personalizada",
    "errors": {
      "inCompetition": "Saia da arena ou do torneio primeiro.",
      "rateLimited": "Mesas demais. Espere um instante.",
      "tableGone": "Essa mesa não está mais disponível.",
      "hostGone": "Quem abriu esta mesa não está mais aqui.",
      "ownTable": "Esta mesa é sua.",
      "invalidSettings": "Essas configurações não são válidas.",
      "startFailed": "Não foi possível começar a partida. Tente de novo.",
      "generic": "Algo deu errado. Tente de novo."
    }
  },
  "spectate": {
    "watch": "Assistir",
    "watchPlayer": "Assistir à partida de {{username}}",
    "watchPair": "Assistir {{a}} contra {{b}}",
    "watching": "Assistindo",
    "leave": "Sair",
    "loading": "Carregando a partida...",
    "turnWhite": "Brancas jogam",
    "turnBlack": "Pretas jogam",
    "whiteWins": "Brancas vencem",
    "blackWins": "Pretas vencem",
    "draw": "Empate",
    "gameOver": "Fim de partida",
    "betweenLegs": "Partida de ida encerrada: a de volta começa em breve",
    "unavailable": "Esta partida não está mais disponível",
    "error": {
      "notPlaying": "Este jogador não está mais em partida.",
      "unavailable": "Esta partida não está mais disponível.",
      "busy": "Você não pode assistir a uma partida enquanto joga.",
      "self": "Esta partida é sua — abra-a pelo seu tabuleiro."
    },
    "watchers": {
      "empty": "Ninguém está assistindo agora."
    }
  },
  "auth": {
    "signIn": "Entrar",
    "signUp": "Cadastrar",
    "preferredVariantHint": "Você pode mudar isso quando quiser",
    "createAccount": "Criar conta",
    "noAccount": "Ainda não tem conta?",
    "hasAccount": "Já tem uma conta?",
    "fields": {
      "username": "Nome de usuário",
      "email": "E-mail",
      "password": "Senha",
      "confirmPassword": "Confirmar senha",
      "emailOrUsername": "E-mail ou nome de usuário"
    },
    "placeholders": {
      "chooseUsername": "Escolha um nome de usuário",
      "yourEmail": "seu@email.com",
      "atLeast8Chars": "Pelo menos 8 caracteres",
      "confirmYourPassword": "Confirme a sua senha",
      "enterEmailOrUsername": "Digite o e-mail ou o nome de usuário",
      "yourPassword": "A sua senha"
    },
    "errors": {
      "passwordsNoMatch": "As senhas não coincidem",
      "passwordTooShort": "A senha precisa ter pelo menos 8 caracteres",
      "usernameTooShort": "O nome de usuário precisa ter pelo menos 3 caracteres",
      "passwordRequirements": "A senha precisa ter pelo menos uma letra maiúscula, uma minúscula e um número",
      "network": "Sem conexão com a internet. Verifique a sua conexão e tente de novo.",
      "guestLoginFailed": "Não foi possível entrar como convidado. Verifique a conexão e tente de novo.",
      "guestLoginRateLimited": "Muitos acessos como convidado nesta rede. Tente de novo daqui a alguns minutos, ou entre com a sua conta."
    },
    "validation": {
      "usernameChars": "Só letras, números e sublinhados",
      "invalidEmail": "Digite um endereço de e-mail válido",
      "min8": "8+ caracteres",
      "uppercase": "maiúscula",
      "lowercase": "minúscula",
      "number": "número"
    },
    "playAsGuest": "Jogar como convidado",
    "guestBanner": "Você está jogando como convidado.",
    "guestBannerCta": "Cadastre-se para guardar o seu progresso.",
    "guestUpgrade": "Criar conta",
    "guestRestriction": "Este recurso precisa de uma conta cadastrada",
    "guestCannotTournament": "Cadastre-se para entrar em torneios",
    "guestCannotChallenge": "Cadastre-se para desafiar jogadores",
    "forgotPassword": "Esqueci a senha",
    "forgotPasswordDesc": "Digite o seu e-mail e mandamos um link para redefinir a senha.",
    "sendResetLink": "Enviar link de redefinição",
    "resetEmailSent": "Confira o seu e-mail",
    "checkSpam": "Não achou? Olhe a pasta de spam.",
    "backToLogin": "Voltar para entrar",
    "resetPassword": "Redefinir senha",
    "resetPasswordDesc": "Digite a sua nova senha abaixo.",
    "newPassword": "Nova senha",
    "confirmPassword": "Confirmar senha",
    "resetSuccess": "Senha atualizada. Agora você já pode entrar.",
    "resetExpired": "Este link de redefinição expirou. Peça um novo.",
    "resetInvalid": "Link de redefinição inválido ou expirado.",
    "verifyEmail": {
      "title": "Confira o seu e-mail",
      "checkInbox": "Mandamos um link de verificação para {{email}}. Clique no link para ativar a sua conta.",
      "spamHint": "Não achou? Olhe a pasta de spam.",
      "pageTitle": "Verificação de e-mail",
      "verifying": "Verificando o seu e-mail...",
      "success": "E-mail verificado. Sua conta está ativa.",
      "successAndBack": "E-mail verificado. Estamos levando você de volta ao torneio.",
      "verifyButton": "Verificar meu e-mail",
      "error": "A verificação falhou. Tente de novo.",
      "loginBlocked": "Verifique o seu e-mail antes de entrar",
      "resendLink": "Reenviar e-mail de verificação",
      "resendSent": "E-mail de verificação enviado!",
      "enterEmailToResend": "Entre com o seu endereço de e-mail para reenviar a verificação",
      "wrongAddress": "Endereço errado?",
      "changeAddress": "Corrigir o endereço",
      "newAddressLabel": "Novo endereço de e-mail",
      "passwordLabel": "A senha que você acabou de escolher",
      "changeSubmit": "Enviar para o novo endereço",
      "changeSent": "Se a conta existir e estiver aguardando verificação, enviamos o link para o novo endereço.",
      "changeFailed": "Não foi possível mudar o endereço. Tente de novo daqui a alguns minutos."
    }
  },
  "profile": {
    "title": "Perfil",
    "notFound": "Perfil não encontrado",
    "userNotFound": "Usuário não encontrado",
    "memberSince": "Membro desde {{date}}",
    "goBack": "Voltar",
    "loadingProfile": "Carregando o perfil...",
    "tabs": {
      "overview": "Visão geral",
      "games": "Partidas",
      "stats": "Números"
    },
    "variants": {
      "all": "Todas"
    },
    "stats": {
      "rating": "Rating",
      "games": "Partidas",
      "wins": "Vitórias",
      "losses": "Derrotas",
      "draws": "Empates",
      "winRate": "Aproveitamento",
      "winRateShort": "Aproveit.",
      "winLossBreakdown": "Vitórias · Empates · Derrotas",
      "peakRating": "Rating máximo",
      "streak": "Sequência",
      "bestStreak": "Melhor",
      "avgTime": "Tempo médio",
      "title": "Estatísticas detalhadas",
      "comingSoon": "Em breve...",
      "loading": "Carregando as estatísticas...",
      "noData": "Nenhuma partida jogada ainda. Jogue um pouco para ver as suas estatísticas!",
      "byTimeControl": "Desempenho por ritmo",
      "byVariant": "Desempenho por variante",
      "byColor": "Desempenho por cor",
      "general": "Geral",
      "asWhite": "De brancas",
      "asBlack": "De pretas",
      "totalGames": "Total de partidas",
      "avgMoves": "Média de lances",
      "gamesShort": "partidas",
      "mostActive": "Jogadores mais ativos",
      "mostActiveEmpty": "Ainda não há partidas nesta variante.",
      "viewFullLeaderboard": "Ver o ranking completo",
      "ratingEvolution": "Evolução do rating · últimos 30 dias",
      "chartComingSoon": "Histórico em breve",
      "peakShort": "Máx",
      "barraEsito": "{{win}}% vitórias, {{draw}}% empates, {{loss}}% derrotas",
      "percentualeVittorie": "{{rate}}% de vitórias",
      "siglaVittorie": "V",
      "siglaPatte": "E",
      "siglaSconfitte": "D"
    },
    "games": {
      "today": "Hoje",
      "yesterday": "Ontem",
      "daysAgo": "há {{days}} dias",
      "weeksAgo": "há {{weeks}} sem.",
      "moves": "lances",
      "sourceArena": "Arena",
      "sourceTournament": "Torneio",
      "loading": "Carregando as partidas...",
      "noGames": "Nenhuma partida encontrada",
      "clearFilters": "Limpar filtros",
      "clearFiltersActive": "Limpar os filtros ativos",
      "loadMore": "Carregar mais",
      "showing": "{{count}} partidas",
      "clickViewAll": "Clique em \"Ver tudo\" para abrir o histórico de partidas",
      "filterResult": "Resultado",
      "filterTimeControl": "Cadência",
      "filterVariant": "Variante",
      "filterOpponent": "Adversário",
      "filters": {
        "all": "Todas",
        "wins": "Vitórias",
        "draws": "Empates",
        "losses": "Derrotas",
        "allVariants": "Todas as variantes",
        "allTimeControls": "Todos os ritmos",
        "vsMe": "Contra mim"
      }
    },
    "challenge": "Desafiar",
    "settings": "Configurações",
    "gameSettings": "Configurações de jogo",
    "preferredVariant": "Variante preferida",
    "preferredCadence": "Cadência preferida",
    "accountSettings": "Conta",
    "audioHaptics": "Som e vibração",
    "changePassword": "Trocar a senha",
    "changePasswordSub": "Atualize a sua senha",
    "currentPassword": "Senha atual",
    "newPassword": "Nova senha",
    "passwordChanged": "Senha trocada com sucesso",
    "analyticsLabel": "Cookies de análise",
    "language": "Idioma",
    "country": "País",
    "countryNone": "Não informado",
    "logout": "Sair",
    "logoutSub": "Sair da sua conta",
    "exportData": "Exportar meus dados",
    "exportDataSub": "Baixe um JSON com os seus dados",
    "deleteAccount": {
      "button": "Excluir a conta",
      "sub": "Exclua a sua conta em definitivo",
      "title": "Excluir a conta",
      "warning": "Esta ação é definitiva e não pode ser desfeita. Todos os seus dados serão excluídos.",
      "confirmPassword": "Digite a sua senha para confirmar",
      "confirm": "Excluir em definitivo",
      "error": "Não foi possível excluir a conta"
    },
    "graphics": {
      "title": "Gráficos",
      "pieceShape": "Formato da peça",
      "pieceStyle": "Estilo da peça",
      "kingIcon": "Ícone da dama",
      "pieceColor": "Cor das peças",
      "pieceColorAutoHint": "As cores das peças mudam a cada variante.",
      "pieceMaterial": "Material das peças",
      "boardColor": "Cor do tabuleiro",
      "boardColorAutoHint": "As cores do tabuleiro mudam a cada variante.",
      "boardMaterial": "Material do tabuleiro",
      "boardNotation": "Notação do tabuleiro",
      "notation": "Notação",
      "shapes": {
        "round": "Redonda",
        "donut": "Rosquinha",
        "square": "Quadrada",
        "rhombus": "Losango",
        "triangle": "Triângulo",
        "star": "Estrela",
        "heart": "Coração"
      },
      "styles": {
        "3d-stacked-engraved": "3D empilhada, gravada",
        "3d-stacked-smooth": "3D empilhada, lisa",
        "3d-crown": "3D com coroa",
        "flat-plain": "Chapada, lisa",
        "flat-engraved": "Chapada, gravada"
      },
      "kingIcons": {
        "crown": "Coroa",
        "ring": "Anel",
        "star": "Estrela",
        "diamond": "Losango",
        "none": "Nenhum"
      },
      "crownType": "Tipo de coroa",
      "crownTypes": {
        "classic": "Clássica",
        "plain": "Simples",
        "diadem": "Diadema",
        "lily": "Flor de lis",
        "imperial": "Imperial"
      },
      "pieceColors": {
        "auto": "Automática (por variante)",
        "custom": "Personalizada…",
        "italian": "Italiana",
        "international": "Internacional",
        "english": "Inglesa",
        "brazilian": "Brasileira",
        "classic": "Clássica",
        "white-black": "Branco/Preto",
        "red-black": "Vermelho/Preto",
        "blue-red": "Azul/Vermelho",
        "orange-blue": "Laranja/Azul (daltônicos)",
        "silver-gold": "Prata/Ouro",
        "coral-teal": "Coral/Turquesa",
        "green-purple": "Verde/Roxo",
        "pink-navy": "Rosa/Azul-marinho"
      },
      "materials": {
        "plastic": "Plástico",
        "marble": "Mármore",
        "glass": "Vidro",
        "wood": "Madeira"
      },
      "boards": {
        "auto": "Automática (por variante)",
        "custom": "Personalizada…",
        "wood-classic": "Internacional",
        "italian": "Italiana",
        "english": "Inglesa",
        "brazilian": "Brasileira",
        "walnut": "Nogueira",
        "green-cream": "Verde/Creme",
        "blue-grey": "Azul/Cinza",
        "marble": "Mármore",
        "high-contrast": "Alto contraste",
        "mahogany": "Mogno",
        "ocean": "Oceano",
        "purple-lavender": "Roxo/Lavanda",
        "rose": "Rosa"
      },
      "notations": {
        "none": "Nenhuma",
        "numeric": "Números",
        "algebraic": "Coordenadas"
      },
      "hue": "Matiz",
      "customPieceLight": "Peças claras",
      "customPieceDark": "Peças escuras",
      "customBoardLight": "Casas claras",
      "customBoardDark": "Casas escuras",
      "picker": {
        "edit": "Editar as cores",
        "hex": "Hex",
        "area": "Saturação e brilho",
        "saturation": "Saturação",
        "brightness": "Brilho",
        "tooClose": "Estas duas cores são muito parecidas — pode ficar difícil distinguir peças ou casas."
      },
      "uiTheme": "Tema do aplicativo",
      "themes": {
        "light": "Claro",
        "dark": "Escuro"
      }
    },
    "game": {
      "title": "Partida",
      "moveSound": "Ligar o som dos lances",
      "lowTimeSound": "Ligar o som de tempo curto",
      "notificationSound": "Ligar os sons de aviso",
      "vibration": "Ligar a vibração nos lances"
    },
    "gameplay": {
      "title": "Jogabilidade",
      "showMoveHints": "Mostrar os lances possíveis",
      "showLastMove": "Destacar o último lance",
      "showLastMoveCaptures": "Destacar as capturas",
      "premove": "Ligar os lances antecipados"
    },
    "avatar": {
      "title": "Escolha um avatar",
      "choose": "Avatares disponíveis",
      "remove": "Sem avatar",
      "edit": "Trocar o avatar",
      "presets": {
        "crown": "Coroa",
        "star": "Estrela",
        "flame": "Chama",
        "zap": "Raio",
        "shield": "Escudo",
        "rocket": "Foguete",
        "gem": "Joia",
        "leaf": "Folha",
        "moon": "Lua",
        "sun": "Sol",
        "heart": "Coração",
        "ghost": "Fantasma"
      }
    },
    "viewProfileOf": "Ver o perfil de {{username}}",
    "report": {
      "trigger": "Denunciar {{username}}",
      "title": "Denunciar {{username}}",
      "intro": "Conte-nos o que está errado neste perfil. Um moderador vai analisar.",
      "reasonLabel": "Motivo",
      "reasons": {
        "offensive_username": "Nome de usuário ofensivo",
        "offensive_avatar": "Imagem de perfil ofensiva",
        "harassment": "Assédio ou ameaças",
        "spam": "Spam ou publicidade",
        "other": "Outro"
      },
      "noteLabel": "Detalhes (opcional)",
      "notePlaceholder": "Algo que nos ajude a entender",
      "privacyHint": "A denúncia fica guardada por {{days}} dias para moderação. O perfil é público: não guardamos nenhuma cópia.",
      "submit": "Enviar denúncia",
      "sending": "Enviando...",
      "done": "Denúncia enviada. Obrigado.",
      "errors": {
        "duplicate": "Você já denunciou este jogador. Um moderador está analisando.",
        "notFound": "Este jogador não está mais disponível.",
        "self": "Você não pode denunciar a si mesmo.",
        "registeredOnly": "É preciso ter uma conta registrada para denunciar daqui.",
        "rateLimited": "Muitas denúncias. Tente mais tarde.",
        "generic": "Não foi possível enviar a denúncia. Tente novamente."
      }
    }
  },
  "gamesHistory": {
    "title": "Histórico de partidas",
    "gamesPlayed": "{{count}} partidas jogadas",
    "noGames": "Nenhuma partida ainda. Jogue online e elas aparecerão aqui!",
    "signInToView": "Entre para ver o seu histórico de partidas.",
    "loadingGames": "Carregando partidas...",
    "loadingGame": "Carregando partida...",
    "failedToLoad": "Não foi possível carregar as partidas",
    "moves": "{{count}} lances"
  },
  "replay": {
    "backToGames": "Voltar às partidas",
    "loadFailed": "Não conseguimos abrir esta partida. Tente de novo.",
    "result": {
      "whiteWins": "Brancas vencem",
      "blackWins": "Pretas vencem",
      "draw": "Empate"
    },
    "controls": {
      "goToStart": "Ir para o início",
      "previousMove": "Lance anterior",
      "nextMove": "Próximo lance",
      "goToEnd": "Ir para o fim",
      "play": "Reproduzir",
      "pause": "Pausar",
      "showMoves": "Mostrar os lances",
      "hideMoves": "Ocultar os lances",
      "position": "Posição na partida"
    },
    "downloadPdn": "Baixar PDN",
    "openInEditor": "Estudar no editor",
    "share": "Compartilhar",
    "shareCopied": "Link copiado!",
    "shareTitle": "Partida de damas",
    "shareText": "Dá uma olhada nesta partida de damas",
    "shareSheet": {
      "pdnTitle": "Baixar PDN",
      "withNotes": "Com as minhas notas ({{count}})",
      "withoutNotes": "Sem as notas",
      "pdnIntro": "As notas viram comentários dentro do arquivo PDN."
    }
  },
  "review": {
    "save": {
      "save": "Salvar partida",
      "saved": "Salva",
      "title": "Salvar partida",
      "intro": "Escolha uma pasta para reencontrar esta partida.",
      "confirm": "Salvar",
      "remove": "Tirar das salvas",
      "error": "Não foi possível salvar a partida"
    },
    "folders": {
      "unsorted": "Sem pasta",
      "newLabel": "Nova pasta",
      "newPlaceholder": "Nome da pasta",
      "create": "Criar",
      "duplicate": "Já existe uma pasta com este nome",
      "rename": "Renomear",
      "renameFolder": "Renomear “{{name}}”",
      "renameLabel": "Novo nome da pasta",
      "renameError": "Não foi possível renomear a pasta",
      "delete": "Excluir",
      "deleteFolder": "Excluir “{{name}}”",
      "deleteConfirm": "Excluir?",
      "deleteHint": "As partidas não são excluídas: voltam para “Sem pasta”.",
      "deleteError": "Não foi possível excluir a pasta",
      "filterLabel": "Pasta",
      "savedOnly": "Só as salvas",
      "gameCount_one": "{{count}} partida",
      "gameCount_other": "{{count}} partidas"
    },
    "notes": {
      "add": "Adicionar nota",
      "atStart": "Nota sobre a posição inicial",
      "atMove": "Nota no lance {{ply}}",
      "placeholder": "Escreva uma nota sobre esta posição…",
      "save": "Salvar nota",
      "delete": "Excluir nota",
      "jumpTo": "Ir para a nota do lance {{ply}}",
      "error": "Não foi possível salvar a nota",
      "hasNote": "Esta posição tem uma nota"
    }
  },
  "leaderboard": {
    "title": "Ranking",
    "subtitle": "Os 100 melhores jogadores",
    "loading": "Carregando o ranking...",
    "empty": "Ainda não há jogadores com partidas concluídas.",
    "allTime": "Rating",
    "mostGames": "Mais ativos",
    "bullet": "Bullet",
    "blitz": "Blitz",
    "rapid": "Rápida",
    "classical": "Clássica",
    "columns": {
      "rank": "#",
      "player": "Jogador",
      "rating": "Rating",
      "class": "Classe",
      "games": "Partidas"
    },
    "period": {
      "label": "Dias",
      "days": "{{days}} dias",
      "all": "Sempre"
    },
    "emptyPeriod": "Nenhuma partida nesta variante nos últimos {{days}} dias.",
    "classes": {
      "novice": "Iniciante",
      "intermediate": "Intermediário",
      "advanced": "Avançado",
      "expert": "Especialista",
      "master": "Mestre",
      "grandmaster": "Grande mestre",
      "legend": "Lenda"
    }
  },
  "tournament": {
    "title": "Torneios",
    "subtitle": "Ponha o seu jogo à prova em torneios de verdade",
    "list": {
      "heroTitle": "Os torneios",
      "arenasLink": "Ver todas as arenas",
      "archive_one": "O último torneio encerrado.",
      "archive_other": "Os últimos {{count}} torneios encerrados."
    },
    "createTournament": "Criar um torneio",
    "formats": {
      "arena": "Arena",
      "italoSwiss": "Todos contra todos/Suíço (conforme os inscritos)",
      "swiss": "Sistema suíço",
      "roundRobin": "Round Robin (todos contra todos)",
      "arenaShort": "Arena",
      "italoSwissShort": "Todos contra todos/Suíço",
      "swissShort": "Suíço",
      "roundRobinShort": "Todos contra todos"
    },
    "filters": {
      "all": "Todos",
      "live": "Ao vivo",
      "upcoming": "Em breve",
      "variant": "Variante",
      "status": "Situação",
      "international": "Internacional",
      "italian": "Italiana",
      "english": "Inglesa",
      "brazilian": "Brasileira",
      "comingSoon": "Em breve",
      "owner": "Torneios",
      "mine": "Meus"
    },
    "sections": {
      "live": "Em andamento",
      "upcoming": "Em breve",
      "finished": "Encerrados"
    },
    "status": {
      "live": "AO VIVO",
      "upcoming": "EM BREVE",
      "finished": "ENCERRADO",
      "scheduled": "AGENDADO",
      "cancelled": "CANCELADO"
    },
    "card": {
      "rated": "Valendo rating",
      "registered": "Inscrito",
      "gamesPlayed_one": "{{count}} partida jogada",
      "gamesPlayed_other": "{{count}} partidas jogadas",
      "players_one": "{{count}} jogador",
      "players_other": "{{count}} jogadores",
      "starts": "Começa {{time}}",
      "startsAt": "Começa às {{time}}",
      "startsAtTomorrow": "Começa amanhã às {{time}}",
      "startsAtDate": "Começa em {{date}} às {{time}}",
      "startsInCountdown": "Começa em {{time}}",
      "startingNow": "Começando agora!",
      "privateHint": "Torneio privado: é preciso um convite ou a senha",
      "publicHint": "Torneio público: aberto a todos",
      "private": "Privado",
      "seats": "Vagas",
      "yourPlace": "você em {{rank}}º",
      "gettoneAlle": "Começa às",
      "gettoneDomani": "Amanhã às",
      "gettoneData": "{{date}} às",
      "gettoneTra": "Começa em",
      "gettoneMin": "min"
    },
    "empty": {
      "live": "Nenhum torneio ao vivo neste momento.",
      "upcoming": "Nenhum torneio agendado.",
      "all": "Nenhum torneio disponível.",
      "mine": "Você não tem torneios. Crie um ou entre com um convite.",
      "finished": "Ainda não há torneios encerrados.",
      "goLive": "Ver os que estão ao vivo",
      "goUpcoming": "Ver o que vem por aí",
      "goFinished": "Ver o arquivo"
    },
    "loading": "Carregando os torneios...",
    "notFound": "Torneio não encontrado",
    "detail": {
      "timeControl": "Ritmo",
      "duration": "Duração",
      "players": "Jogadores",
      "games": "Partidas",
      "startsIn": "Começa {{time}}",
      "joinTournament": "Entrar no torneio",
      "register": "Inscrever-se",
      "unregister": "Cancelar inscrição",
      "leaveTournament": "Sair do torneio",
      "yourStats": "Os seus números",
      "points": "Pontos",
      "rank": "Posição",
      "askPassword": "Senha do torneio",
      "share": "Compartilhar convite",
      "shareStandings": "Compartilhar a classificação",
      "shareCopied": "Link copiado",
      "cancelTournament": "Cancelar torneio",
      "cancelConfirm": "O torneio desaparece e todos os inscritos são avisados. Não há como voltar atrás.",
      "cancelYes": "Sim, cancelar",
      "cancelNo": "Não, manter",
      "createdBy": "Criado por {{username}}",
      "regenerate": "Novas chaves",
      "regenerateHint": "O link antigo para de funcionar. Escolha uma nova senha e reenvie o convite.",
      "regenerateNewPassword": "Nova senha",
      "regenerateConfirm": "Criar novas chaves",
      "regenerateCancel": "Deixa pra lá",
      "regenerateDone": "Chaves refeitas: o link antigo não vale mais",
      "ratingFloor": "Pontuação mínima",
      "aiutoAssenza": "O que acontece se eu não jogar?",
      "aiutoApertura": "Por que algumas partidas começam com lances já jogados?",
      "formatoTitolo": "Como o formato é decidido",
      "formatoOraGirone": "Com os inscritos de agora ({{n}}) seria um todos contra todos.",
      "formatoOraSvizzero": "Com os inscritos de agora ({{n}}) seria um suíço.",
      "formatoOraPochi": "Para começar são necessários pelo menos {{min}} inscritos: agora são {{n}}.",
      "formatoPrevisto": "Previsto",
      "seSvizzero": "Se for suíço",
      "seGirone": "Se for todos contra todos",
      "punteggio": "Pontuação"
    },
    "scoring": {
      "title": "Pontuação da arena",
      "win": "Vitória: +{{points}}",
      "draw": "Empate: +{{points}}"
    },
    "standings": {
      "title": "Classificação",
      "liveStandings": "Classificação ao vivo",
      "empty": "Ainda não há jogadores. Seja o primeiro a entrar!",
      "morePlayers_one": "+ {{count}} jogador",
      "morePlayers_other": "+ {{count}} jogadores",
      "columns": {
        "rank": "#",
        "player": "Jogador",
        "points": "Pontos",
        "status": "Situação",
        "winsDrawsLosses": "V/E/D",
        "winsDrawsLossesByes": "V/E/D/F",
        "byes": "Folga"
      },
      "status": {
        "playing": "Jogando",
        "ready": "Pronto",
        "paused": "Pausado",
        "left": "Saiu",
        "offline": "Offline",
        "assente": "Ausente",
        "haFinito": "Aguardando",
        "riposa": "Descansa",
        "disconnesso": "Desconectado"
      },
      "tied": "Empatado",
      "tiebreakHelp": "Como se desempata?",
      "sdSigla": "CD",
      "sdSpiega": "À frente de {{nomi}} nos confrontos diretos entre os empatados",
      "scoreSheet": {
        "label": "Desempenho: {{esiti}}",
        "outcome": {
          "win": "vitória",
          "winPlus": "vitória, valendo mais",
          "draw": "empate",
          "loss": "derrota",
          "bye": "folga"
        },
        "clipped": "as mais antigas ficam de fora à esquerda",
        "hint": "Todas as partidas, a mais recente à direita",
        "hintRiposoSvizzero": "o quadrado é uma folga e vale como uma vitória",
        "hintRiposoGirone": "o quadrado é uma folga e não dá pontos"
      }
    },
    "lobby": {
      "leaveTournament": "Sair do torneio",
      "waitingForOpponent": "Esperando um adversário...",
      "pts": "pts",
      "rank": "posição",
      "yourPosition": "A sua posição"
    },
    "timer": {
      "remaining": "Falta",
      "finished": "Encerrado",
      "started": "Começou",
      "daysHours": "{{days}}d {{hours}}h"
    },
    "tabs": {
      "standings": "Classificação",
      "games": "Partidas",
      "details": "Detalhes",
      "participants": "Participantes",
      "gamesPlaceholder": "As partidas recentes vão aparecer aqui"
    },
    "rules": {
      "title": "Regras de pontuação"
    },
    "create": {
      "title": "Criar um torneio",
      "infoAbout": "Sobre {{campo}}",
      "nameLabel": "Nome do torneio *",
      "namePlaceholder": "ex.: Arena Blitz de domingo",
      "nameRequired": "O nome do torneio é obrigatório",
      "aperturaUnicaHint": "Uma só abertura para todas as rodadas e todas as partidas do torneio — útil para um torneio temático sobre uma única abertura",
      "aperturaUnicaScelta": "nº {{id}}",
      "aperturaUnicaScegli": "Escolha a abertura",
      "aperturaUnicaMancante": "Escolha uma abertura para continuar",
      "aperturaUnicaAmichevole": "Esta abertura é desequilibrada demais para uma única partida compensá-la: o torneio é amistoso. Com ida e volta continua valendo rating.",
      "nameLength": "O nome precisa ter de 3 a 100 caracteres",
      "descriptionLabel": "Descrição (opcional)",
      "descriptionPlaceholder": "Descreva o seu torneio...",
      "timeControlLabel": "Ritmo",
      "durationLabel": "Duração",
      "startsAtLabel": "Horário de início",
      "startsAtRange": "De 5 minutos a 14 dias a partir de agora.",
      "startsAtInvalid": "Escolha um horário entre 5 minutos e 14 dias a partir de agora.",
      "visibilityLabel": "Visibilidade",
      "visibilityPublic": "Público",
      "visibilityPrivate": "Privado",
      "passwordLabel": "Senha do torneio",
      "passwordHint": "Você poderá relê-la depois para compartilhar. Não use a senha da sua conta.",
      "passwordRequired": "Um torneio privado precisa de uma senha",
      "estimate": "{{players}} jogadores, {{rounds}} rodadas → cerca de {{duration}}, fim por volta das {{end}}",
      "estimateRange": "{{players}} jogadores, de {{roundsMin}} a {{roundsMax}} rodadas → cerca de {{duration}}, fim até as {{end}}",
      "durationOptions": {
        "30min": "30 min",
        "1hour": "1 hora",
        "1.5hours": "1 hora e meia",
        "2hours": "2 horas",
        "3hours": "3 horas"
      },
      "minRatingLabel": "Rating mínimo",
      "maxRatingLabel": "Rating máximo",
      "ratedLabel": "Valendo rating",
      "ratingFloorLabel": "Pontuação mínima",
      "ratingFloorHint": "Abaixo desta pontuação não é possível entrar. Ela é medida pela sua pontuação na variante e no ritmo deste torneio: quem nunca jogou essa combinação conta como estreante. Apenas em torneios valendo pontos.",
      "ratingFloorNone": "Nenhuma",
      "variantLabel": "Variante",
      "variantInternational": "Internacional (10×10)",
      "variantItalian": "Italiana (8×8)",
      "variantEnglish": "Inglesa (8×8)",
      "formatLabel": "Formato",
      "maxPlayersLabel": "Máx. jogadores",
      "thresholdLabel": "Suíço desde",
      "thresholdHint": "De {{n}} inscritos para cima joga-se pelo sistema suíço; abaixo disso, todos contra todos. As rodadas são fixadas no início, contando quem apareceu. Com três ou quatro inscritos, o todos contra todos também tem returno: continuam três rodadas, mas de duas partidas cada, porque uma partida por adversário seria pouco demais.",
      "extraRoundLabel": "Rodadas extra (suíço)",
      "extraRoundHint": "Uma ou duas rodadas a mais do que a tabela dá, até onde o grupo aguentar. Não muda nada no todos contra todos: lá todos se enfrentam, e uma rodada a mais seria um returno para todos.",
      "extraRoundsNone": "Nenhuma",
      "extraRoundsOne": "+1 rodada",
      "extraRoundsTwo": "+2 rodadas",
      "tooLongWarningSeats": "Mais de um dia de jogo: tire algumas vagas ou encurte o ritmo.",
      "minPlayersLabel": "Mín. jogadores",
      "minPlayersHint": "Abaixo desse número o torneio se cancela sozinho na hora de início. Quanto mais você aumentar, mais provável isso fica.",
      "seatsWarning": "Acima desse número ninguém mais poderá entrar, e você não poderá mudar depois.",
      "submitButton": "Criar torneio",
      "submitting": "Criando...",
      "failedToCreate": "Não foi possível criar o torneio",
      "arenaHint": "Uma arena não tem rodadas: você é emparelhado continuamente até o tempo acabar.",
      "arenaDurationHint": "Quanto tempo a arena fica aberta. No máximo oito horas.",
      "arenaSummary": "Arena de {{duration}}, termina por volta das {{end}}",
      "twoLegLabel": "Ida e volta",
      "twoLegHint": "Cada emparelhamento é jogado duas vezes seguidas, com as cores invertidas.",
      "twoLegItaloHint": "As mesmas duas pessoas se enfrentam duas vezes na mesma rodada, com as cores invertidas e a mesma abertura: a rodada dura o dobro, o número de rodadas não dobra. Com três ou quatro inscritos o returno é sempre jogado, diga o que disser esta chave.",
      "boostLabel": "Boost",
      "boostHint": "Quem joga pode apostar: abre mão de metade do tempo base e do incremento, e uma vitória vale o dobro. Pega-se antes da própria primeira jogada. Desligado, ninguém o usa nesta arena.",
      "roundsHelp": "Quantas rodadas são jogadas?"
    },
    "games": {
      "allGames": "Todas as partidas",
      "myGames": "Minhas partidas",
      "noGames": "Nenhuma partida jogada ainda",
      "moves": "lances",
      "analyze": "Analisar",
      "round": "Rodada {{n}}"
    },
    "participants": {
      "sortByScore": "Por pontos",
      "sortByRating": "Por rating",
      "sortByName": "A-Z",
      "status": {
        "playing": "Jogando",
        "online": "Online",
        "offline": "Offline"
      }
    },
    "matchFound": {
      "title": "Partida encontrada!",
      "opponent": "Adversário",
      "playAsWhite": "Você joga de brancas",
      "playAsBlack": "Você joga de pretas",
      "startingIn": "Começando em...",
      "startNow": "Começar agora"
    },
    "postGame": {
      "currentRank": "Posição atual",
      "continue": "Continuar"
    },
    "signInToJoin": "Entre para participar dos torneios",
    "roundRobin": {
      "scontroDiretto": "Confronto direto entre os jogadores com a mesma pontuação (na classificação «CD»)",
      "tiebreakerInfo": "Critérios de desempate: vitórias, confronto direto, Sonneborn-Berger, variação de rating no torneio"
    },
    "swiss": {
      "roundOf": "Rodada {{current}} de {{total}}",
      "scoringWin": "Vitória: +{{points}}",
      "scoringDraw": "Empate: +{{points}}",
      "scoringLoss": "Derrota: {{points}}",
      "buchholz": "BH",
      "sb": "SB",
      "variazione": "Δ",
      "variazioneTitolo": "Variação de rating no torneio",
      "criterioVittorie": "Número de vitórias",
      "tiebreakersTitle": "Critérios de desempate",
      "buchholzCut1": "Buchholz (Cut 1)",
      "sonnebornBerger": "Sonneborn-Berger (SB)",
      "cannotJoinInProgress": "Este torneio suíço já começou. Não dá para entrar com ele em andamento.",
      "returnLegPending": "A volta está prestes a começar: os mesmos adversários, cores invertidas.",
      "waitingBetweenRounds": "Esperando a próxima rodada...",
      "waitingFinalResults": "Esperando os resultados finais...",
      "waitingForRoundEnd": "Esperando a rodada terminar...",
      "tiebreakerInfo": "Critérios de desempate: Buchholz Cut 1, Sonneborn-Berger, vitórias, variação de rating no torneio",
      "byeRoundPunti": "Nesta rodada você descansa: +{{punti}} pontos, já na classificação.",
      "byeRoundNessunPunto": "Nesta rodada você descansa: em pontos corridos o descanso não dá pontos.",
      "byeProssimoTurno": "A próxima rodada começa sozinha quando as outras partidas terminarem.",
      "byeUltimoTurno": "Os resultados finais chegam quando as outras partidas terminarem.",
      "returnLegTra": "A volta começa em {{secondi}} s: os mesmos adversários, cores invertidas.",
      "partiteConcluse": "Partidas encerradas: {{completate}} de {{totali}}",
      "turnoParteDaSolo": "A próxima rodada começa sozinha",
      "nonCiSiRitira": "Com o torneio iniciado, não é possível desistir: se você não jogar, continua emparelhado e perde suas partidas por tempo."
    },
    "errors": {
      "authRequired": "Entre para participar de um torneio.",
      "guestNotAllowed": "Torneios são para contas registradas.",
      "notAllowed": "Operação não permitida.",
      "notFound": "Este torneio já não existe.",
      "userNotFound": "Jogador não encontrado.",
      "invalidInput": "Solicitação inválida.",
      "rateLimited": "Muitas solicitações: aguarde um momento.",
      "joinFailed": "Não foi possível entrar. Tente de novo.",
      "arenaPiena": "Esta arena está lotada: não há mais vagas.",
      "arenaChiusa": "Esta arena não aceita mais inscrições.",
      "giaIscritto": "Você já está inscrito nesta arena.",
      "arenaAnnullata": "Esta arena foi cancelada: no horário de início não havia inscritos suficientes.",
      "notJoinable": "As inscrições neste torneio estão encerradas.",
      "roundsStarted": "A rodada já começou.",
      "ratingTooLow": "Sua pontuação está abaixo do mínimo exigido por este torneio.",
      "wrongFormat": "Formato de torneio incompatível.",
      "privateTournament": "Este torneio é privado: você precisa do link ou da senha.",
      "wrongPassword": "Senha incorreta.",
      "tooManyAttempts": "Tentativas demais. Tente de novo em quinze minutos.",
      "tournamentFull": "O torneio está lotado.",
      "alreadyHasLive": "Você já tem 3 competições em andamento: poderá abrir outra quando uma delas terminar.",
      "nameTaken": "Já existe um torneio com esse nome nesse horário.",
      "startTooSoon": "Cedo demais: deixe pelo menos cinco minutos para convidar alguém.",
      "startTooFar": "Longe demais: no máximo duas semanas a partir de agora.",
      "notOrganizer": "Só quem abriu o torneio pode fazer isso.",
      "alreadyStarted": "O torneio já começou.",
      "tooLong": "O torneio duraria mais de um dia: tire algumas rodadas ou encurte o ritmo.",
      "cancelledByOrganizer": "O organizador cancelou este torneio.",
      "cancelledNoPlayers": "O torneio foi cancelado: não houve inscritos suficientes.",
      "serverError": "Erro do servidor. Tente mais tarde.",
      "offline": "Você parece estar offline: verifique a conexão.",
      "timeout": "O servidor não respondeu. Tente de novo.",
      "loadFailed": "Não foi possível carregar os torneios.",
      "notYourTurn": "Não é a sua vez.",
      "drawOfferFailed": "Não foi possível propor empate.",
      "unknown": "Algo deu errado. Tente de novo.",
      "moveRejected": "O servidor recusou o seu lance: o tabuleiro voltou como estava.",
      "partitaSvanita": "A partida não está mais no servidor: ele provavelmente foi reiniciado. Você voltou ao saguão do torneio.",
      "notInTournament": "Você não está inscrito neste torneio.",
      "tournamentFullWayOut": "Ver outros torneios e arenas",
      "notPrivate": "Este torneio é público: não tem chaves para refazer",
      "samePassword": "A nova senha é igual à anterior",
      "tournamentCancelled": "O torneio foi cancelado.",
      "inviteLinkExpired": "Este link de convite não vale mais: entre com a senha."
    },
    "ended": {
      "title": "Torneio encerrado",
      "winner": "Vencedor",
      "noWinner": "Sem vencedor: nenhuma partida foi jogada.",
      "tiedWith": "Primeiro empatado com {{players}}"
    },
    "share": {
      "title": "Torneio de damas",
      "text": "Você foi convidado para o torneio {{nome}} em draughtsgame.com",
      "standingsTitle": "Classificação final — {{nome}}"
    }
  },
  "chat": {
    "title": "Bate-papo",
    "openChat": "Abrir o bate-papo",
    "closeChat": "Fechar o chat",
    "empty": "Ainda não há mensagens. Diga um oi!",
    "placeholder": "Escreva uma mensagem...",
    "unavailable": "Bate-papo indisponível",
    "opponentLeft": "Seu adversário saiu da partida.",
    "rateLimited": "Você está escrevendo rápido demais: espere alguns segundos.",
    "closingIn": "O bate-papo fecha em {{seconds}}s",
    "closed": "O bate-papo desta partida está fechado.",
    "guestHint": "Convidados só enviam reações rápidas. Cadastre-se para usar o bate-papo completo.",
    "report": {
      "trigger": "Denunciar",
      "title": "Denunciar {{username}}",
      "intro": "Conte o que aconteceu. Um moderador vai revisar o bate-papo desta partida.",
      "quoteLabel": "Última mensagem de {{username}}",
      "reasonLabel": "Motivo",
      "reasons": {
        "insult": "Insultos ou linguagem ofensiva",
        "harassment": "Assédio ou ameaças",
        "hate_speech": "Discurso de ódio ou discriminação",
        "spam": "Spam ou propaganda",
        "other": "Outra coisa"
      },
      "noteLabel": "Detalhes (opcional)",
      "notePlaceholder": "Qualquer coisa que nos ajude a entender",
      "privacyHint": "O bate-papo desta partida (até 100 mensagens, dos dois jogadores) é guardado para moderação e mantido por {{days}} dias.",
      "submit": "Enviar denúncia",
      "sending": "Enviando...",
      "done": "Denúncia enviada. Obrigado.",
      "muted": "Você denunciou este jogador. As mensagens dele estão ocultas.",
      "errors": {
        "gone": "Esta partida acabou e o bate-papo dela não pode mais ser verificado. Escreva para nós pela página de Ajuda.",
        "duplicate": "Você já denunciou este jogador nesta partida.",
        "notReportable": "Este adversário não pode ser denunciado.",
        "notInGame": "Você não é jogador desta partida.",
        "rateLimited": "Denúncias demais. Tente de novo mais tarde.",
        "generic": "Não foi possível enviar a denúncia. Tente de novo."
      }
    },
    "quickPhrases": "Frases rápidas",
    "presets": {
      "hello": "Olá!",
      "goodLuck": "Bom jogo!",
      "haveFun": "Divirta-se!",
      "goodGame": "Boa partida!",
      "untilNext": "Até a próxima!",
      "thanks": "Obrigado!"
    }
  },
  "landing": {
    "nav": {
      "title": "Damas Online",
      "play": "Jogar",
      "tournaments": "Torneios",
      "learn": "Aprender",
      "community": "Comunidade",
      "login": "Entrar"
    },
    "hero": {
      "badge": "A experiência definitiva das damas",
      "title": "Domine a arte das damas",
      "subtitle": "Jogue contra gente do mundo inteiro, dispute torneios e melhore o seu jogo com as nossas ferramentas de treino.",
      "playFree": "Jogar agora",
      "watchDemo": "Ver a demonstração"
    },
    "stats": {
      "players": "Jogadores ativos",
      "games": "Partidas jogadas",
      "variants": "Variantes de jogo",
      "tournaments": "Torneios diários"
    },
    "features": {
      "title": "Por que escolher o Damas Online?",
      "subtitle": "Tudo o que você precisa para virar mestre nas damas",
      "variants": {
        "title": "Várias variantes",
        "description": "Jogue damas italianas, internacionais, inglesas e brasileiras — tudo numa plataforma só."
      },
      "matchmaking": {
        "title": "Pareamento inteligente",
        "description": "O nosso sistema de rating Glicko-2 garante partidas justas e disputadas toda vez."
      },
      "tournaments": {
        "title": "Torneios arena",
        "description": "Dispute torneios diários com jogadores do mundo inteiro."
      },
      "ai": {
        "title": "Treino com IA",
        "description": "Treine contra a nossa IA avançada, com vários níveis de dificuldade."
      },
      "analysis": {
        "title": "Análise de partidas",
        "description": "Reveja as suas partidas e aprenda com os seus erros usando uma análise detalhada."
      },
      "community": {
        "title": "Comunidade ativa",
        "description": "Entre em clubes, converse com jogadores e faça amigos que gostam do mesmo que você."
      }
    },
    "variants": {
      "title": "Jogue a sua variante preferida",
      "subtitle": "Damos suporte às variantes de damas mais populares do mundo",
      "pieces": "peças",
      "italian": "Damas italianas",
      "international": "Damas internacionais",
      "english": "Damas inglesas",
      "brazilian": "Damas brasileiras"
    },
    "testimonials": {
      "1": {
        "name": "Marco B.",
        "role": "Jogador de torneios",
        "text": "A melhor plataforma de damas que já usei. O pareamento é justo e os torneios são empolgantes!"
      },
      "2": {
        "name": "Elena V.",
        "role": "Jogadora casual",
        "text": "Adoro como é fácil achar uma partida. A interface é bonita e intuitiva."
      },
      "3": {
        "name": "Hans K.",
        "role": "Campeão de clube",
        "text": "Enfim uma plataforma que leva as damas internacionais a sério. Recomendo muito!"
      },
      "title": "O que dizem os jogadores"
    },
    "cta": {
      "title": "Pronto para jogar?",
      "subtitle": "Junte-se a milhares de jogadores e comece hoje a sua jornada nas damas.",
      "button": "Começar a jogar agora"
    },
    "footer": {
      "tagline": "A principal plataforma de damas online",
      "game": "Jogo",
      "playNow": "Jogar agora",
      "tournaments": "Torneios",
      "leaderboard": "Ranking",
      "puzzles": "Problemas",
      "learn": "Aprender",
      "tutorial": "Tutorial",
      "strategies": "Estratégias",
      "rules": "Regras",
      "videos": "Vídeos",
      "community": "Comunidade",
      "forum": "Fórum",
      "clubs": "Clubes",
      "blog": "Blog",
      "discord": "Discord",
      "rights": "Todos os direitos reservados."
    }
  },
  "arena": {
    "title": "Arena",
    "subtitle": "Jogo contínuo, num ritmo puxado",
    "ending": "Encerrando...",
    "status": {
      "live": "AO VIVO",
      "upcoming": "EM BREVE",
      "finished": "ENCERRADA"
    },
    "card": {
      "yourPlace": "você em {{rank}}º"
    },
    "actions": {
      "join": "Entrar na arena",
      "leave": "Sair",
      "play": "Jogar",
      "pause": "Pausar",
      "resume": "Retomar",
      "boost": "Turbo",
      "backToGame": "Voltar à partida",
      "retry": "Tentar de novo"
    },
    "errors": {
      "authRequired": "Você precisa estar conectado para participar da arena.",
      "guestNotAllowed": "Contas de convidado não podem entrar em uma arena. Crie uma conta para guardar as suas partidas.",
      "notAllowed": "Esta conta não pode entrar em uma arena.",
      "arenaNotFound": "Esta arena não existe mais.",
      "userNotFound": "Não achamos a sua conta. Entre de novo, por favor.",
      "invalidInput": "O pedido não era válido. Recarregue a página e tente de novo.",
      "rateLimited": "Tentativas demais. Espere alguns segundos e tente de novo.",
      "ratingTooLow": "Sua pontuação está abaixo do mínimo exigido por esta arena.",
      "joinFailed": "Não foi possível inscrever você na arena. Tente de novo.",
      "arenaPiena": "Esta arena está lotada: não há mais vagas.",
      "arenaChiusa": "Esta arena não aceita mais inscrições.",
      "giaIscritto": "Você já está inscrito nesta arena.",
      "arenaScaduta": "O tempo desta arena terminou: só se espera o fim das últimas partidas.",
      "arenaAnnullata": "Esta arena foi cancelada.",
      "arenaAnnullataPochiIscritti": "Esta arena foi cancelada: no horário de início não havia inscritos suficientes.",
      "arenaAnnullataDaOrganizzatore": "Quem abriu esta arena a cancelou.",
      "notOrganizer": "Só quem abriu a arena pode fazer isso.",
      "alreadyStarted": "A arena já começou.",
      "giaInUnArena": "Você já está em uma arena em andamento: saia dela para jogar nesta",
      "leaveFailed": "Não foi possível tirar você da arena. Tente de novo.",
      "notInArena": "Você não está inscrito nesta arena.",
      "notInGame": "Você não está jogando esta partida.",
      "gameNotFound": "Esta partida não existe mais.",
      "tooLate": "Tarde demais: o turbo só pode mudar antes do seu primeiro lance.",
      "boostDisabled": "Nesta arena o boost está desligado.",
      "alreadyBoosted": "O turbo já está ligado nesta partida.",
      "notBoosted": "O turbo não está ligado nesta partida.",
      "boostFailed": "Não foi possível ligar o turbo. Tente de novo.",
      "unboostFailed": "Não foi possível desligar o turbo. Tente de novo.",
      "serverError": "Algo deu errado do nosso lado. Tente de novo.",
      "offline": "Sem conexão com o servidor.",
      "timeout": "O servidor não respondeu. Tente de novo.",
      "unknown": "Algo deu errado. Tente de novo.",
      "notYourTurn": "Não é a sua vez.",
      "drawOfferFailed": "Não conseguimos enviar a sua proposta de empate. Tente de novo.",
      "moveRejected": "O servidor recusou o seu lance: o tabuleiro voltou como estava."
    },
    "standings": {
      "search": "Procurar um jogador",
      "searchEmpty": "Nenhum jogador com esse nome.",
      "sheetHint": "Todas as partidas, a mais recente à direita · dourado = bônus",
      "loadMore": "Mostrar mais",
      "sheet": "Partidas",
      "toClimb_one": "{{count}} ponto para subir",
      "toClimb_other": "{{count}} pontos para subir",
      "lead_one": "{{count}} ponto de vantagem",
      "lead_other": "{{count}} pontos de vantagem",
      "boostOn": "turbo ligado",
      "searchScope": "A busca só olha as linhas já carregadas: carregue o resto para procurar entre todos.",
      "justPlayedHint": "A marca ↺: você acabou de jogar contra essa pessoa — ao lado está quanto falta para ela poder ser sorteada de novo.",
      "justPlayedIn": "Já enfrentado: disponível de novo em {{time}}"
    },
    "info": {
      "details": "Detalhes",
      "scoring": "Sistema de pontuação",
      "loss": "Derrota: {{points}}",
      "boostTitle": "Turbo ⚡",
      "boostTimeCost": "Tira o seu acréscimo e corta o seu tempo base pela metade",
      "boostExtraPoint": "Dobra os pontos da vitória se você ganhar",
      "boostBeforeFirst": "Pode ser ligado e desligado até o seu primeiro lance"
    },
    "matchFound": {
      "title": "Adversário encontrado",
      "opponent": "Adversário",
      "playAsWhite": "Você joga de brancas",
      "playAsBlack": "Você joga de pretas",
      "startingIn": "Começando em",
      "startNow": "Começar agora"
    },
    "gameEnd": {
      "win": "Vitória",
      "loss": "Derrota",
      "draw": "Empate",
      "pointsEarned": "Pontos ganhos",
      "basePoints": "Pontos base",
      "boostBonus": "Bônus do turbo",
      "total": "Total",
      "pointsVoided": "Partida não contabilizada: nenhum ponto para os dois jogadores",
      "rank": "Posição",
      "totalPoints": "Pontos",
      "paused": "Você está pausado: retome quando quiser.",
      "arenaFinished": "Arena encerrada",
      "arenaDraining": "Tempo esgotado: a arena fecha assim que as últimas partidas terminarem.",
      "analyze": "Analisar",
      "pause": "Pausado",
      "playNext": "Continuar",
      "backToArena": "Voltar à arena",
      "resumeFailed": "Não conseguimos colocar você de volta na fila: verifique a sua conexão e tente de novo.",
      "returnLegIn_one": "Volta em {{count}} segundo…",
      "returnLegIn_other": "Volta em {{count}} segundos…"
    },
    "game": {
      "boost": "Turbo",
      "boostRemove": "Remover",
      "boostRetry": "Tentar de novo"
    },
    "confirmBoost": {
      "title": "Ativar o turbo?",
      "halve": "Seu tempo base vai de {{prima}} para {{dopo}} e você perde o incremento de {{incremento}}s.",
      "halveOnly": "Seu tempo base vai de {{prima}} para {{dopo}}.",
      "reward": "Se você vencer, os pontos valem o dobro. Dá para remover até o seu primeiro lance.",
      "confirm": "Ativar"
    },
    "results": {
      "arenaFinished": "Arena encerrada",
      "yourPosition": "A sua posição",
      "outOf_one": "entre {{count}} jogador",
      "outOf_other": "entre {{count}} jogadores",
      "yourStats": "Os seus números",
      "totalPoints": "Total de pontos",
      "gamesPlayed": "Partidas jogadas",
      "games": "partidas",
      "wins": "Vitórias",
      "draws": "Empates",
      "losses": "Derrotas",
      "winRate": "Aproveitamento",
      "boostUsed": "Turbos usados",
      "share": "Compartilhar",
      "nextArena": "Próxima arena",
      "unavailable": "Não temos os resultados desta arena.",
      "unavailableSub": "Volte à lista e abra de novo pela aba \"Encerradas\"."
    },
    "tabs": {
      "rules": "Regras"
    },
    "signInToJoin": "Entre para participar das arenas",
    "positionCta": "Entre e dispute para subir na classificação!",
    "band": {
      "searchingTitle": "Procurando um adversário",
      "searchingSub": "Assim que eu achar um par, levo você para a partida.",
      "drainingTitle": "O tempo acabou",
      "drainingSub": "Não faço mais pares: assim que as últimas partidas terminarem, sai a classificação final.",
      "pausedTitle": "Você está pausado",
      "pausedSub": "Ninguém é pareado com você até você retomar.",
      "pausedAwaySub": "Pausei você porque o aplicativo ficou em segundo plano. Retome quando quiser.",
      "pausedOfflineSub": "Coloquei você em pausa porque estava offline quando a arena começou.",
      "pausedOtherArenaSub": "Você está jogando na outra arena. Quando terminar lá, toque em Retomar para voltar à fila aqui.",
      "playingTitle": "Você está em partida",
      "playingSub": "A partida continua aberta: volte para ela.",
      "playingSubVs": "Contra {{opponent}} · de {{color}}.",
      "waitingTitle": "Você está dentro",
      "waitingSub": "A arena ainda não começou.",
      "joinTitle": "Você está fora",
      "joinSub": "Entre e eu pareio você com quem estiver na fila."
    },
    "timebar": {
      "endsIn": "Termina em"
    },
    "games": {
      "mine": "Minhas",
      "deletedPlayer": "Jogador excluído",
      "loadFailed": "Não conseguimos carregar as partidas."
    },
    "a11y": {
      "scoreUpdate": "Agora {{points}} pontos, {{rank}}º lugar"
    },
    "spotlight": {
      "eyebrow": "Arena",
      "daysHours": "{{days}}d {{hours}}h",
      "startsIn": "Começa em",
      "yourResult": "Você terminou em {{rank}}º",
      "review": "Ver como foi"
    },
    "twoLeg": "Ida e volta",
    "noBoost": "Sem boost",
    "share": {
      "title": "Arena de damas",
      "text": "Você foi convidado para a arena {{nome}} em draughtsgame.com"
    },
    "detail": {
      "askPassword": "Senha da arena",
      "share": "Compartilhar convite",
      "shareCopied": "Link copiado",
      "cancelArena": "Cancelar arena",
      "cancelConfirm": "A arena desaparece e todos os inscritos são avisados. Não dá para voltar atrás."
    }
  },
  "specialEvent": {
    "eyebrow": "Evento especial",
    "badge": "Especial",
    "organizedBy": "Organizado pelo Draughts Game"
  },
  "legal": {
    "termsTitle": "Termos",
    "privacyTitle": "Privacidade",
    "acceptTerms": "Aceito os <terms>Termos de Serviço</terms> e a <privacy>Política de Privacidade</privacy>",
    "acceptTermsOnly": "Aceito os <terms>Termos de Serviço</terms>",
    "acceptPrivacyOnly": "Aceito a <privacy>Política de Privacidade</privacy>",
    "ageConfirm": "Confirmo que tenho pelo menos 16 anos",
    "acceptRequired": "Você precisa aceitar os Termos de Serviço",
    "acceptTermsRequired": "Marque esta caixa para aceitar os Termos de Serviço",
    "acceptPrivacyRequired": "Marque esta caixa para aceitar a Política de Privacidade",
    "ageRequired": "Marque esta caixa para confirmar a sua idade",
    "lastUpdated": "Última atualização",
    "subtitle": "Os seus direitos e os nossos compromissos",
    "missingConsents_one": "Ainda falta {{count}} caixa para marcar acima",
    "missingConsents_other": "Ainda faltam {{count}} caixas para marcar acima"
  },
  "cookies": {
    "message": "Usamos cookies essenciais para o site funcionar. Se você aceitar, usamos também ferramentas de medição — Umami, para saber como o site é usado, e Sentry, para detectar erros. Você pode recusar: o site funciona do mesmo jeito.",
    "acceptAll": "Aceitar tudo",
    "rejectAnalytics": "Só os essenciais"
  },
  "puzzle": {
    "toPlayAndWin": "jogam e vencem",
    "black": "Pretas",
    "white": "Brancas",
    "dashboard": "Painel",
    "hint": "Dica",
    "hintTip": "Uma dica só custa o rating: este problema passa a não valer pontos, então você não ganha nem perde nada. Ele ainda conta como resolvido e mantém a sua sequência.",
    "solution": "Solução",
    "solutionTip": "Revelar a solução conta como tentativa falha: você perde pontos de rating, mas o dia continua contando para a sua sequência.",
    "continueVsAI": "Continuar contra a IA",
    "playAgain": "Jogar de novo",
    "back": "Voltar",
    "forward": "Avançar",
    "puzzleRating": "Rating do problema",
    "ratingChange": "Rating",
    "newRating": "agora",
    "yourRating": "O seu rating",
    "solutionMoves": "Solução",
    "moves": "lances",
    "motifs": "Motivos",
    "motifsRevealed": "revelados",
    "motifsHidden": "revelados depois de resolver",
    "result": {
      "solvedEyebrow": "Resolvido",
      "failedEyebrow": "Solução",
      "nice": "Bem",
      "solving": "resolvido.",
      "theLine": "Esta é a",
      "line": "linha."
    },
    "title": "Problemas",
    "loading": "Carregando o problema...",
    "yourTurn": "Ache o melhor lance!",
    "correct": "Isso!",
    "incorrect": "Não é isso",
    "solved": "Problema resolvido!",
    "failed": "Problema não resolvido",
    "giveUp": "Desistir",
    "nextPuzzle": "Próximo problema",
    "backToHome": "Voltar ao início",
    "rating": "Rating",
    "daily": "Problema do dia",
    "solve": "Resolver",
    "demo": {
      "badge": "Problema de demonstração",
      "solvedTitle": "Boa — resolvido!",
      "trainTitle": "Quer treinar todo dia?",
      "registerPitch": "Crie uma conta grátis: um problema novo por dia, um diferente para cada variante.",
      "registerCta": "Criar uma conta grátis"
    },
    "practice": "Treinar",
    "share": "Compartilhar",
    "shareTitle": "Problema do dia",
    "shareText": "Resolvi o problema do dia — você consegue?",
    "shareCopied": "Link copiado!",
    "retry": "Tentar de novo",
    "unavailable": {
      "title": "Este problema não está disponível",
      "link": "Não conseguimos abrir o problema de hoje. Pode não haver problema do dia para esta variante, ou a conexão caiu.",
      "session": "Não conseguimos começar este problema. Verifique a sua conexão e tente de novo.",
      "home": "Ir para a página inicial"
    },
    "invite": {
      "title": "O problema do dia está esperando por você",
      "body": "Um amigo compartilhou com você o problema do dia. Os problemas diários são só para jogadores cadastrados — crie uma conta grátis, ou entre, para liberar o tabuleiro.",
      "locked": "Prévia bloqueada",
      "tryDemo": "Experimente o problema de demonstração enquanto isso",
      "moves_one": "{{count}} lance",
      "moves_other": "{{count}} lances"
    },
    "guest": {
      "locked": "Os daily puzzles são reservados aos jogadores cadastrados. Entre ou crie uma conta gratuita para jogá-los."
    },
    "networkError": "Problema de rede: o lance não foi registrado. Tente de novo."
  },
  "dashboard": {
    "hero": {
      "welcome": "Bem-vindo de volta",
      "settings": "Configurações",
      "ctaPlayNow": "Jogar agora",
      "ctaVsComputer": "Desafiar a IA",
      "moreVariants": "Mais variantes ({{count}})",
      "logoutConfirmTitle": "Sair da conta?",
      "logoutConfirmBody": "Você vai sair da sua conta neste aparelho.",
      "ctaDailyPuzzle": "Problemas do dia",
      "themeDark": "Mudar para o tema escuro",
      "themeLight": "Mudar para o tema claro",
      "ratingDeltaUp": "{{points}} pontos ganhos nos últimos 7 dias",
      "ratingDeltaDown": "{{points}} pontos perdidos nos últimos 7 dias"
    },
    "notif": {
      "challengedYou": "<b>{{name}}</b> ({{rating}}) desafiou você para <b>{{timeControl}}</b> · {{variant}}",
      "challengedYouNoRating": "<b>{{name}}</b> desafiou você para <b>{{timeControl}}</b> · {{variant}}",
      "accept": "Aceitar",
      "decline": "Recusar"
    },
    "streak": {
      "daysInRow_one": "{{count}} dia seguido",
      "daysInRow_other": "{{count}} dias seguidos",
      "unitLabel_one": "dia seguido",
      "unitLabel_other": "dias seguidos",
      "record": "Recorde a bater: <b>{{count}} dias</b>",
      "recordTying": "Recorde igualado: <b>{{count}} dias</b>",
      "empty": "Comece hoje",
      "solvePuzzle": "Resolver um problema",
      "doneToday": "Feito por hoje 🔥",
      "keepHint": "Jogue ou resolva um problema para manter a sua sequência.",
      "last7DaysLabel": "Atividade dos últimos 7 dias"
    },
    "dailyGoal": {
      "title": "Meta do dia",
      "label": "Partidas",
      "remaining_one": "<b>Falta uma</b> para bater a meta",
      "remaining_other": "<b>Faltam {{count}}</b> para bater a meta",
      "done": "Meta batida",
      "targetLabel": "Partidas por dia",
      "editGoal": "Alterar a meta do dia"
    },
    "activity": {
      "title": "Atividade",
      "last3Months": "Últimos 3 meses",
      "centerGames": "partidas",
      "statsGames_one": "{{count}} partida",
      "statsGames_other": "{{count}} partidas",
      "statsActiveDays_one": "{{count}} dia ativo",
      "statsActiveDays_other": "{{count}} dias ativos",
      "statsPerDay": "{{value}} partidas/dia",
      "empty": "As suas partidas vão aparecer aqui",
      "statsTotalTime": "{{value}} no total",
      "tooltipToday": "Hoje",
      "tooltipYesterday": "Ontem",
      "legendBucket0": "0",
      "legendBucket1": "1-2",
      "legendBucket2": "3-5",
      "legendBucket3": "6-9",
      "legendBucket4": "10+",
      "duration": {
        "zero": "0 min",
        "minutes_one": "{{count}} min",
        "minutes_other": "{{count}} min",
        "hours_one": "{{count}}h",
        "hours_other": "{{count}}h",
        "hoursMinutes": "{{hours}}h {{minutes}}m"
      },
      "dayMon": "Seg",
      "dayThu": "Qui",
      "daySat": "Sáb",
      "dayTue": "Ter",
      "dayWed": "Qua",
      "dayFri": "Sex",
      "daySun": "Dom"
    },
    "recentGames": {
      "title": "Partidas recentes",
      "viewAll": "Ver todas no perfil →",
      "replay": "Rever",
      "empty": "Nenhuma partida ainda"
    },
    "upcomingTournaments": {
      "title": "Torneios ativos",
      "viewAll": "Ver todos →",
      "viewAllAria": "Ver todos os torneios",
      "empty": "Nenhum torneio agendado"
    },
    "liveEvent": {
      "emptyTitle": "Torneios e arenas",
      "empty": "Nenhum evento ao vivo neste momento",
      "nextAt": "O próximo Diário começa às {{time}}",
      "minutesLeft_one": "Termina em {{count}} minuto",
      "minutesLeft_other": "Termina em {{count}} minutos",
      "participants_one": "{{count}} jogador",
      "participants_other": "{{count}} jogadores"
    },
    "puzzle": {
      "titleWhiteToMove": "Brancas jogam\ne vencem",
      "titleBlackToMove": "Pretas jogam\ne vencem",
      "meta": "Ache a melhor sequência",
      "cta": "Resolver →",
      "viewAll": "Todos →",
      "tag": {
        "tactic": "Tática"
      },
      "solvedNext": "Resolvido ✓ · Volte amanhã para o próximo",
      "tryInternational": "Experimente um problema de internacional →",
      "overlayTitle": "Problemas do dia"
    },
    "avvisoDati": {
      "offline": "Parece que você está sem conexão — os seus dados não carregaram.",
      "server": "Não foi possível carregar os seus dados.",
      "inCorso": "Tentando de novo…",
      "ricarica": "Recarregar"
    },
    "installCard": {
      "eyebrow": "App",
      "title": "Instale o Draughts Game",
      "benefit": "Adicione à tela de início: abre em tela cheia, inicia mais rápido e fica junto dos seus outros apps.",
      "howTo": "Como faço?",
      "choose": "Escolha seu dispositivo:",
      "os": {
        "android": "Android",
        "ios": "iPhone ou iPad",
        "desktop": "Computador"
      }
    }
  },
  "pwa": {
    "openInAppText": "Você está no navegador do WhatsApp. Abra este link fora dele para usar o aplicativo direito.",
    "openInAppCta": "Abrir no aplicativo",
    "openInBrowserText": "Você está no navegador do WhatsApp. Abra este link no Safari para ter a experiência completa.",
    "iosHint": "Toque em ••• no canto inferior direito e depois em “Abrir no Safari”.",
    "installText": "Instale o Draughts Game para jogar direto da sua tela de início.",
    "installCta": "Instalar o aplicativo",
    "copyLink": "Copiar link",
    "linkCopied": "Link copiado!",
    "dismiss": "Dispensar"
  },
  "seo": {
    "breadcrumbHome": "Início",
    "landing": {
      "title": "Draughts Game — jogue damas online de graça",
      "description": "Jogue damas online de graça: internacionais, italianas, turcas, frísias e mais 20 variantes. Multijogador em tempo real, partidas valendo rating, torneios, adversários de IA e um problema por dia."
    },
    "faq": {
      "title": "Perguntas frequentes — jogar damas online",
      "description": "Respostas sobre contas, rating, torneios, instalação do aplicativo e partidas online, além de um canal direto para avisos e sugestões."
    },
    "terms": {
      "title": "Termos de Serviço — Draughts Game",
      "description": "As condições que regem o uso do Draughts Game: contas, jogo limpo, rating, conteúdos e as regras aceitas pelos dois lados."
    },
    "privacy": {
      "title": "Política de privacidade — Draughts Game",
      "description": "Quais dados o Draughts Game coleta, por quê, por quanto tempo os mantém e que direitos você tem sobre eles segundo a LGPD e o GDPR."
    }
  }
}
